{
	"BUY_FEATURE": "[QUANTITY] Bonus Buy Spin",
	"FOMO_bets": "FOMO Bets",
	"FOMO_bets02": "FOMO<br />Bets",
	"FOMO_jackpot": "FOMO Jackpot",
	"POWER_BET": "[QUANTITY] Power Bet Spins",
	"REGULAR": "[QUANTITY] Free Spins",
	"SPIN_ONLY_WIN": "[QUANTITY] Garantili Ücretsiz Kazanç",
	"SPIN_UNTIL_YOU_WIN": "Kazanana Kadar Spin",
	"a_probably_fair_system": "SHA256 algoritmasına dayalı, kanıtlanabilir şekilde adil bir sistemdir ve rastgele bir sayı içerir = rastgele kazanan sayı ile sunucunun başlangıç numarasının birleşimi. Her turun kendine ait bir hash’i vardır ve her bahis için benzersiz şekilde oluşturulan rastgele kazançlardan oluşur.",
	"about_us": "Hakkımızda",
	"accept": "Kabul Et",
	"accept_bonus": "Bonusu Kabul Et",
	"accepted": "Kabul Edildi",
	"accepting": "Kabul Ediliyor",
	"account": "Hesap",
	"account_details": "Hesap Detayları",
	"account_merge_into": "Birleştir",
	"account_merge_other_account": "Diğer hesap",
	"account_merge_other_required": "Lütfen diğer hesabın kullanıcı adını girin",
	"account_merge_reason": "Sebep",
	"account_merge_reason_required": "Lütfen birleştirme talebi için bir sebep belirtin",
	"account_merge_request": "Hesap Birleştirme Talebi",
	"account_merge_submit": "Birleştirme Talep Et",
	"account_merge_this_account": "Bu hesap",
	"action": "İşlem",
	"actions": "İşlemler",
	"activate_now": "Şimdi Aktifleştir!",
	"active": "Aktif",
	"active_client_seed": "Aktif Client Seed",
	"active_server_seed": "Aktif Server Seed",
	"add_email_address": "E-posta adresi ekle",
	"add_new_emailSec": "Yeni E-posta Ekle",
	"added_to_balance": "Bakiyeye eklendi",
	"added_to_calendar": "Takvime eklendi",
	"addressLine1Label": "Adres Satırı 1",
	"addressLine1Placeholder": "Adresinizi girin 1",
	"addressLine2Label": "Adres Satırı 2",
	"addressLine2Placeholder": "Adresinizi girin 2",
	"address_temporarily_unavailable": "Bu ağda yatırma hizmetlerinde geçici bir kesinti yaşıyoruz. Sorularınız için lütfen müşteri destek ekibimizle iletişime geçin.",
	"admin": "Admin",
	"advent_calendar": "Advent Takvimi",
	"advent_calendar_banner_description": "Tüm ay boyunca free spinler, super spinler, rake boostlar ve bonusların keyfini çıkar!",
	"advent_calendar_banner_title": "Yılbaşı Takvimi Her Gün Ödüyor",
	"advent_calendar_description": "Günlük kazançları aç: Her hediyenin arkasında ödüller seni bekliyor!",
	"affiliate": "Affiliate",
	"affiliate_agreement": "Bu sözleşme (“Affiliate Sözleşmesi”), siz (“siz” veya “Affiliate”) ile [BRAND].com tarafından işletilen www.[BRAND].partners arasında yapılmıştır. [BRAND].com, Curaçao’da kayıtlı, şirket kayıt numarası 161495 olan ve kayıtlı adresi Zuikertuintjeweg Z/N (Zuikertuin Tower) Curaçao olan King of Clubz B.V.’nin bir marka adıdır (“Şirket”). Şirket, çevrimiçi oyun hizmetleri sunmak üzere Gaming Services Provider N.V. lisansı #365/JAZ kapsamında Curaçao’da lisanslıdır. Affiliate Programına kayıt olarak ve pazarlama araçlarımızdan herhangi birini kullanarak veya Affiliate Programımız kapsamında sunulan herhangi bir ödül, bonus ya da komisyonu kabul ederek, bu Affiliate Sözleşmesini okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz.",
	"affiliate_managers_details": "Her adımda size rehberlik edecek deneyimli affiliate yöneticilerinden oluşan bir ekip.",
	"affiliate_marketing_promotion": "Affiliate pazarlamada iyiseniz, [BRAND] Partners sizin için mükemmel bir programdır. [BRAND] affiliate’i olarak, [BRAND] Casino’da üretilen Net Oyun Gelirinin %50’sine varan oranlarda kazanç elde edebilirsiniz. Kaçırmayın!",
	"affiliate_terms_conditions": "Affiliate Şartlar & Koşullar",
	"affiliates": "Affiliates",
	"agree_to_forfeit": "Bu hesaptaki bonustan feragat etmeyi kabul ediyorum.",
	"alias": "TAKMA AD (GÖRÜNEN İSİM)",
	"alias_on_leaderboards": "Liderlik Tablolarındaki Takma Ad",
	"all": "Tümü",
	"all_bets_fuels_your_rewards": "Tüm bahisler + ödüllerinizi güçlendirir",
	"all_campaigns": "Tüm Kampanyalar",
	"all_currencies": "Diğer Para Birimleri",
	"all_game_providers": "Tüm Oyun Sağlayıcıları",
	"all_games": "Tüm Oyunlar",
	"all_providers": "Tüm sağlayıcılar",
	"all_ranks": "Tüm Seviyeler",
	"all_rights_reserved": "Tüm Hakları Saklıdır",
	"all_tiers_benefits_description": "Tüm seviyeler; Rakeback, Rakeboost, Cashback, Level Up ödülleri ve seviye hoş geldin bonusları gibi artan avantajlara hak kazanır! Seviyen yükseldikçe ödüllerin de artar!",
	"alphabetical": "Alfabetik A-Z",
	"alphabetical_a_z": "Alfabetik A-Z",
	"alphabetical_z_a": "Alfabetik Z-A",
	"alphabetical_za": "Alfabetik Z-A",
	"alpine_skiing": "Alp Disiplini Kayak",
	"american_football": "Amerikan Futbolu",
	"aml_policy": "AML Politikası",
	"amount": "Tutar",
	"amount_fiat": "Fiat Tutarı",
	"amount_of_people": "Kişi sayısı",
	"and_rewards": "Ve ödüller",
	"anniversary_bonus_text": "Yıl Dönümü Bonusu",
	"answer_daily_weekly_monthly": "Günlük, haftalık ve aylık bonusunuz; son oyun aktivitenize, biriken house edge’e ve seviye artışınıza göre verilen bir ödüldür. Ödüller sınırsızdır ve çevrimiçi olarak sunulan en iyiler arasındadır!",
	"answer_how_communicate": "VIP host’unuz, kendinizi en rahat hissettiğiniz iletişim yöntemiyle sizinle iletişime geçecektir. Canlı Sohbet yerine Telegram mı tercih ediyorsunuz? Oradan ulaşacağız. Gizliliğiniz için telefon görüşmeleri yapılmamaktadır.",
	"answer_how_ofter_bonuses": "Flush ile günlük, haftalık ve aylık bonus talep edebilirsiniz! Takviminizi istediğiniz zaman kontrol edin ve bonus birikiminizi buna göre planlayın.",
	"answer_monthly_bonus": "Aylık bonus her ayın 28’inde dağıtılır.",
	"answer_vip_club_stand_out": "Flush size cömert bonus fırsatları sunar! Takviminiz üzerinden kolayca bonus talep edebilir ve herhangi bir sorun yaşarsanız 7/24 destek ekibimize tek tıkla ulaşabilirsiniz.",
	"answer_wagering": "Mevcut tüm oyunlarda yapılan bahisler üzerinden hesaplanır. Bahis yapılan her 1$ için seviye artışına, house edge kazancına ve mevcut cashback’e eşit katkı sağlanır.",
	"answer_what_are_calendar_distribuition_days": "Bu, bonusun ne sıklıkla ödendiğini ifade eder. Günlük, haftalık ve aylık bonuslarımız vardır ve bulunduğunuz seviyeye göre artar. Seviyenize bağlı olarak, belirli günler boyunca bu bonusun bir kısmını her gün alabilirsiniz. Örneğin Platinum III seviyesinde, Gold III’e kıyasla daha fazla gün boyunca daha yüksek bir bonus yüzdesi alırsınız.",
	"answer_what_is_cashback": "Bu, Brüt Oyun Geliri’nin kâr ve zararına dayalı bir ödüldür. Günlük, haftalık ve aylık olarak sunulur ve önceki dönemde ne kadar oynadığınıza bağlıdır.",
	"answer_what_is_happy_hour": "Rakeboost, Flush’ta daha çok Happy Hour olarak bilinir ve günün ilk rakeback talebinin 60 dakika boyunca üç katına çıkmasıdır.",
	"answer_what_is_rakeback": "Rakeback, yapılan bahislerin house edge’i üzerinden hesaplanan bir bonustur. Son talebinizden bu yana yapılan oyunlara göre her 30 dakikada bir açılır ve talep edebilmek için en az 5$ birikmiş olması gerekir.",
	"answer_which_tier_im_on": "Çok kolay! VIP sayfasının üst kısmında görebilir ya da Rewards sayfasına giderek talep edebileceğiniz tüm detayları inceleyebilirsiniz.",
	"approval_time_for_program": "[BRAND] Partners Programı için onaylanmam ne kadar sürer?",
	"approval_time_for_program_answer": "[BRAND] Partners’a kaydolduktan kısa bir süre sonra bir affiliate yöneticisi hesabınızı kurmak için sizinle iletişime geçer. Herhangi bir sorun veya özel gereklilik yoksa, yeni partnerler birkaç iş günü içinde onaylanır.",
	"approving": "Onaylanıyor",
	"are_you_sure_you_want_to_cancel_this_item": "Bu [ITEM]’ı iptal etmek istediğinizden emin misiniz?",
	"are_you_sure_you_want_to_delete_this_item": "Bu [ITEM]’ı silmek istediğinizden emin misiniz?",
	"are_you_sure_you_want_to_disable_item": "[ITEM] devre dışı bırakmak istediğinizden emin misiniz?",
	"are_you_sure_you_want_to_proceed_with_this_action": "Bu işlemi sürdürmek istediğinizden emin misiniz?",
	"as_you_and_your_friends": "Arkadaşların kazandığında bile ödül alırsın!",
	"aussie_rules": "Avustralya Futbolu",
	"available": "Mevcut",
	"available_bonuses": "Mevcut bonuslar",
	"available_on_selected_games": "Seçili oyunlarda geçerlidir",
	"baccarat": "Baccarat",
	"back": "GERİ",
	"badminton": "Badminton",
	"balance": "Bakiye",
	"bank": "Banka",
	"bank_not_allowed": "Şu anda yalnızca Avrupa bankalarına izin verilmektedir.",
	"banks_country": "Bankanın ülkesi",
	"baseball": "Beyzbol",
	"basketball": "Basketbol",
	"become_a_partner": "Partner Ol",
	"become_royalty_text": "Royalty olmak ister misin?",
	"beginner_affiliate_marketing": "Affiliate pazarlamada çok deneyimli değilsem [BRAND] Partners Programına katılabilir miyim?",
	"beginner_affiliate_marketing_answer": "Evet. Önceki deneyim faydalı olabilir ancak zorunlu değildir. Deneyimli affiliate yöneticilerimiz, affiliate pazarlamanın sizin için doğal hale gelmesi adına her adımda size rehberlik edecektir.",
	"best_vip_club": "En İyi [VIP Kulübü]",
	"best_vip_club_description": "[AMOUNT_OF_LEVEL_REWARDS] adede kadar Level Up Ödülü",
	"bet": "Bahis",
	"bet_feed": "Bahis Akışı",
	"bet_id": "Bahis ID",
	"bet_now": "Şimdi bahis yap",
	"bet_on_basketball": "Basketbola Bahis",
	"bet_on_cricket": "Kriket'e Bahis",
	"bet_on_cs2": "CS2'ye Bahis",
	"bet_on_dota2": "Dota 2'ye Bahis",
	"bet_on_f1": "F1'e Bahis",
	"bet_on_football": "Futbola Bahis",
	"bet_on_lol": "LoL'e Bahis",
	"bet_on_tennis": "Tenise Bahis",
	"bet_on_ufc": "UFC'ye Bahis",
	"bet_on_valorant": "Valorant'a Bahis",
	"bet_statistics": "Bahis İstatistikleri",
	"bets": "Bahisler",
	"bets_on_providers": "[PROVIDERS] üzerinde [BETS_AMOUNT] tur oyna (min bahis: [MIN_BET])",
	"big_wins": "Büyük Kazançlar",
	"birthdayInfo": "Doğum gününüz Flush Platformunda nasıl gösterilsin?",
	"birthday_visibility": "Doğum Günü",
	"bitcoin_baccarat": "Bitcoin Bakara",
	"bitcoin_blackjack": "Bitcoin Blackjack",
	"bitcoin_casino": "Bitcoin Casino",
	"bitcoin_crash_game": "Bitcoin Crash Oyunu",
	"bitcoin_dice": "Bitcoin Zar",
	"bitcoin_keno": "Bitcoin Keno",
	"bitcoin_live_casino": "Bitcoin Canlı Casino",
	"bitcoin_mines_game": "Bitcoin Mines Oyunu",
	"bitcoin_play_testimonial": "BitcoinPlay olarak [BRAND] Partners’ı üst seviye bir bitcoin casino partneri olarak görüyoruz. Platformları sezgisel tasarım ve kusursuz navigasyon sunarken, destekleyici affiliate ekipleriyle dinamik ve kazançlı bir iş birliği vadediyor.",
	"bitcoin_roulette": "Bitcoin Rulet",
	"bitcoin_slots": "Bitcoin Slot",
	"bitcoin_sportsbook": "Bitcoin Spor Bahisleri",
	"blackjack": "Blackjack",
	"blaze_zombie": "SPIN. DODGE. HAYATTA KAL. KAZAN!",
	"blaze_zombie_description": "Bu 1 Milyon $’lık turnuvada, günlük 72 bin $ kazanma şansı için Spin Jackpot Blaze & Zombie School Megaways oyna!",
	"blocked_by_browser": "Popup tarayıcı tarafından engellendi.",
	"blog": "Blog",
	"bonus": "Bonus",
	"bonus_100": "%100 bonus, üst limit",
	"bonus_buy_slots": "Bonus Satın Alma Slotları",
	"bonus_buys": "Bonus Buy’lar",
	"bonus_code": "Bonus kodu",
	"bonus_lock": "Çekim yapabilmek için aktif bonusunuzun çevrim şartlarını tamamlamanız gerekir.",
	"bonus_money": "Bonus bakiyesi",
	"bonus_per_referral": "%35’e kadar Komisyon!",
	"bonus_precondition_failed": "Bonus ön koşulu sağlanamadı",
	"bonus_progress": "Bonus İlerlemesi",
	"bonus_terms": "Bonus Şartları",
	"boost_your_holiday": "Tatil oyununu güçlendir: Bugün yatırmana %150 Bonus al",
	"boxing": "Boks",
	"bronze": "Bronz",
	"browse_and_play": "binlerce oyuna göz at",
	"browse_through": "Göz at",
	"button": "Kripto Satın Al",
	"buy": "Satın Al",
	"buy_crypto": "Kripto Satın Al",
	"buy_crypto_disclaimer": "Feragatnameyi okudum ve kabul ediyorum",
	"buy_crypto_tooltip": "ℹ️ Bu hizmet üçüncü taraf Onramper tarafından sağlanmaktadır. Kripto Satın Al’a tıklayarak Onramper ödeme hizmetine yönlendirileceksiniz. Hizmetlerini kullanmadan önce Onramper kullanım şartlarını okuyup kabul ediniz. Ödeme ile ilgili sorular için müşteri desteğiyle iletişime geçin. Flush, herhangi bir kayıp veya zarardan sorumlu değildir. Kripto para satın alındıktan sonra otomatik olarak Flush cüzdanınıza aktarılır.",
	"by": "Tarafından",
	"by_simply_getting": "Sadece arkadaşlarını ve onların arkadaşlarını Flush.com’da oynamaya davet ederek.",
	"calculation": "Hesaplama",
	"calendar": "Noel Takvimi",
	"calendar_bonus": "Takvim Bonusu",
	"calendar_claimable_days": "Talep Edilebilir Takvim Günleri",
	"calendar_distribution_days_text": "Takvim Dağıtım Günleri",
	"calendar_text": "Takvim",
	"campaign_name": "Kampanya adı",
	"campaigns": "Kampanyalar",
	"canada": "Kanada",
	"cancel": "İptal",
	"cancelled": "İptal Edildi",
	"canelo_vs_crawford_description": "Seçimin KO veya TKO ile kazanırsa iki kat kazan!<br /><br /><strong>14 Eylül 2025 | 01:00 UTC</strong>",
	"cannot_receive_tips": "Bahşiş alınamaz",
	"cash": "Nakit",
	"cash_and_drop": "Cash & Drop",
	"cash_back": "cash back",
	"cash_drop": "Crash & Win",
	"cash_drop_description": "Günlük, haftalık ve aylık ödüllerini anında talep et!",
	"cash_fiat_amount_within_limits_hint": "Yukarıda gösterilen limitler dahilinde bir tutar girin.",
	"cash_out": "Çekim Yap",
	"cash_out_cancel_title": "Bonusu almamaya mı karar verdin?",
	"cash_out_earned_title": "Tebrikler! Bonusun çevrim şartlarını tamamladın!",
	"cash_out_forfeit_title": "Gerçek bakiyeni çekip bonusundan vazgeçmek ister misin?",
	"cash_out_success_cancel": "Bonusundan feragat ettin ve bakiyen ana hesabına aktarıldı",
	"cash_out_success_earned": "Bakiyen ana hesabına aktarıldı",
	"cashback": "Cashback",
	"cashback_bonuses_description": "Cashback Bonusları",
	"casino": "Casino",
	"casino_bonus": "Casino Bonusu",
	"casino_card_title": "Şuna kadar\n%150",
	"casino_promotions": "Casino Promosyonları",
	"casino_subtitle": "Aralarından seçebileceğin 5.000+ oyun",
	"challenges": "meydan okumalar",
	"champions_league_free_bet": "10 $ bahis yap, 10 $ kazan",
	"champions_league_free_bet_description": "Place a $10 Champions League bet and unlock a $10 Free Bet",
	"change": "Değiştir",
	"changeAlias": "Görünen İsmi Değiştir",
	"character_limit_reached": "Karakter sınırına ulaştınız",
	"chat": "Sohbet",
	"chat_deposit_required": "Sohbeti kullanmadan önce para yatırmanız gerekir",
	"chat_emojis_activity_category": "Aktivite",
	"chat_emojis_flags_category": "Bayraklar",
	"chat_emojis_foods_category": "Yiyecekler",
	"chat_emojis_nature_category": "Doğa",
	"chat_emojis_objects_category": "Nesneler",
	"chat_emojis_people_category": "İnsanlar",
	"chat_emojis_places_category": "Yerler",
	"chat_emojis_recents_category": "Son Kullanılanlar",
	"chat_emojis_symbols_category": "Semboller",
	"chat_invalid_content": "Mesaj desteklenmeyen içerik barındırıyor",
	"chat_media_emojis_tab": "Emoji",
	"chat_media_gifs_tab": "GIF’ler",
	"chat_media_stickers_tab": "Sticker’lar",
	"chat_muted_description": "Sohbet kurallarının ihlali nedeniyle önümüzdeki [REMAINING_HOURS] boyunca mesaj gönderemezsiniz. Lütfen saygılı olun.",
	"chat_muted_permanent_description": "Sohbet kurallarının tekrarlanan veya ciddi ihlalleri nedeniyle artık mesaj gönderemezsiniz.",
	"chat_muted_title": "Sessize alındınız.",
	"chat_rules": "Sohbet Kuralları",
	"chat_search_emojis_placeholder": "Emoji Ara",
	"chat_search_gifs_placeholder": "Tenor Üzerinden GIF Ara",
	"check": "Kontrol Et",
	"check_your_email_for": "E-postanı kontrol et:",
	"choose_a_display_name": "bir görünen isim seç",
	"choose_a_password": "Bir şifre seç",
	"choose_a_username": "Bir kullanıcı adı seç",
	"christmas_advent": "Noel Advent",
	"christmas_calendar": "Noel Takvimi",
	"cityLabel": "Şehir",
	"cityPlaceholder": "Şehrinizi girin",
	"claim": "Talep Et",
	"claim_now": "Şimdi Talep Et!",
	"claim_total_in": "[AMOUNT] tutarını şu sürede talep et:",
	"claim_your_rewards": "Günlük, haftalık ve aylık ödüllerini anında talep et!",
	"claim_your_slice": "10.000 $’lık ödül havuzundan payını al",
	"claimed": "Talep Edildi",
	"clear": "Temizle",
	"click_on_one_of_the_games": "[10 Garantili Ücretsiz Kazanç] talep etmek için aşağıdaki oyunlardan birine tıkla.",
	"click_to_continue": "Devam etmek için tıkla",
	"click_to_copy": "Kopyalamak için tıkla",
	"client_seed": "Client Seed",
	"close": "Kapat",
	"coming_soon": "Çok Yakında",
	"comission_plan": "Komisyon planı:",
	"commision_shares": "Komisyon payları",
	"commission": "her ay gerçek nakit",
	"commission_calculation_details": "[BRAND] Partners Programında komisyonlar nasıl hesaplanır?",
	"commission_calculation_details_answer": "Affiliate kazançları, yönlendirdikleri oyuncuların davranışlarına ve özellikle Net Oyun Geliri’ne (NGR) bağlıdır. Affiliate’ler, [BRAND] Casino’ya yönlendirdikleri oyuncuların ürettiği NGR’nin üzerinde anlaşılan yüzdesini alır.",
	"commission_from_new_affiliates": "Yeni affiliate’ler yönlendirerek komisyon kazanabilir miyim?",
	"commission_from_new_affiliates_answer": "Evet. [BRAND] Partners, affiliate’lerin alt affiliate’lerinin kazançlarından da komisyon elde edebileceği bir Master Affiliate programı sunar. Daha fazla bilgi için deneyimli affiliate yöneticilerimizden biriyle görüşün.",
	"commission_levels_panel_footnote_active": "“En aktif” tanımı, takvim ayı boyunca toplam nakit turnover’a göre belirlenir.",
	"commission_levels_panel_footnote_monthly_cap": "Bu, her ay en fazla 155 ödüllendirilen referral demek!",
	"commission_levels_panel_intro": "Arkadaşların (veya onların arkadaşları) bahis yaptığında komisyon kazanırsın. Kazansalar bile!",
	"commission_levels_panel_tier1_badge": "Tier 1",
	"commission_levels_panel_tier1_description": "Aylık en aktif 5 doğrudan referral’ınız üzerinden %20 komisyon kazanırsınız.",
	"commission_levels_panel_tier1_title": "Birincil referral’lar",
	"commission_levels_panel_tier2_badge": "Tier 2",
	"commission_levels_panel_tier2_description": "Tier 1 oyuncularının her birinin en aktif 5 referral’ından %10 kazanırsın (en fazla 25).",
	"commission_levels_panel_tier2_title": "İkincil referral’lar",
	"commission_levels_panel_tier3_badge": "Tier 3",
	"commission_levels_panel_tier3_description": "Her Tier 2 oyuncunun en aktif 5 referral’ından %5 kazanırsın (en fazla 125).",
	"commission_levels_panel_tier3_title": "Üçüncül referral’lar",
	"commission_levels_title": "Komisyon Seviyeleri",
	"commission_payment_frequency": "Komisyonlar affiliate’lere ne sıklıkla ödenir?",
	"commission_payment_frequency_answer": "Affiliate komisyonları, kazançların oluştuğu ayı takip eden ayın ilk 10 günü içinde hesaplanır ve ödenir.",
	"commission_percentage": "Komisyon %",
	"commission_plan": "Komisyon Planı",
	"commission_rewards": "Komisyon Ödülleri",
	"commission_schemes_details": "Yönlendirmelerinizin değerini en üst düzeye çıkaran kazançlı komisyon planları.",
	"commission_shares": "Komisyon Payları",
	"commission_sharings": "Komisyon Paylaşımları",
	"comp": "Nakit",
	"company": "Şirket",
	"complaints_and_arbitration": "Şikayetler ve Tahkim",
	"complete_all_fields": "Önce tüm alanları ve gereklilikleri tamamlamalısınız:",
	"completed": "Tamamlandı",
	"confirm": "Onayla",
	"confirm_age_terms": "18 yaşından büyük olduğumu ve Hizmet Şartlarını okuduğumu onaylıyorum.",
	"confirmed": "Onaylandı",
	"confirming": "Onaylanıyor",
	"congratulations": "Tebrikler",
	"connect_wallet": "Cüzdanı bağla",
	"connected": "Bağlı",
	"connected_accounts": "Bağlı Hesaplar",
	"connected_wallet": "Bağlı Cüzdan",
	"consistent_rewards_description": "Tutarlı Ödüller",
	"consolation": "Teselli",
	"contact_partners": "[BRAND] Partners ile nasıl iletişime geçebilirim?",
	"contact_partners_answer": "Aşağıdaki formu kullanarak ekiple iletişime geçin",
	"contact_support": "Destekle İletişime Geç",
	"contact_support_for_assistance": "Yardım için destekle iletişime geçin",
	"contact_us": "Bize Ulaşın",
	"continue": "Devam Et",
	"cookies_modal_text": "En iyi deneyimi sunabilmek için çerezler kullanıyoruz",
	"coolDownPeriodDisabled": "Cooldown Talep Et",
	"cooldown": "KENDİNİ DIŞLAMA",
	"cooldownPeriodEnabled": "Cooldown Süresi Aktif",
	"cooldownPeriodRequested": "Cooldown Süresi Talep Edildi",
	"cooldown_tab": "Kendini Dışlama",
	"copied": "Kopyalandı!",
	"copied_address": "Adres kopyalandı!",
	"copied_long": "Panoya başarıyla kopyalandı ve paylaşmaya hazır",
	"counter_strike": "Counter Strike",
	"countryLabel": "Ülke",
	"countryPlaceholder": "Ülkenizi seçin",
	"crash": "Crash",
	"crash_and_win": "Crash & Win",
	"create_a_new_campaign": "Yeni bir kampanya oluştur",
	"create_account": "Hesap oluştur",
	"create_free_account": "Ücretsiz hesap oluştur",
	"create_new_campaign": "Yeni kampanya oluştur",
	"create_referral_code": "Referans kodu oluştur",
	"created": "Oluşturuldu",
	"credit_card": "Kart",
	"credited": "Hesaba geçti",
	"cricket": "Kriket",
	"cross_country": "Kros",
	"crypto": "Kripto",
	"crypto_casino": "[BRAND] Casino",
	"crypto_casino_description": "Binlerce casino ve canlı casino oyunu sunan saf bir kripto casino. 2021’de Curaçao lisansı ile kurulan [BRAND] Casino; yatırma işlemleri için birçok kripto para seçeneği ve mobil uygulamasıyla, kripto trafiğinizi gelire dönüştürmenize yardımcı olacak mükemmel bir markadır. Daha fazlasını öğrenmek için affiliate ekibimizle iletişime geçin.",
	"crypto_crash_game": "Kripto Crash Oyunu",
	"crypto_dice_game": "Kripto Zar Oyunu",
	"crypto_game_shows": "Kripto Oyun Programları",
	"crypto_market_watch": "Kripto Piyasa Takibi",
	"crypto_plinko": "Kripto Plinko",
	"crypto_select_currency": "para birimi seçin",
	"crypto_select_network": "ağ seçin",
	"crypto_slots": "Kripto Slot",
	"crypto_video_poker": "Kripto Video Poker",
	"crypto_wheel": "Kripto Çark",
	"crypto_wheel_of_fortune": "Kripto Şans Çarkı",
	"currency": "Para birimi",
	"currency_in_play": "Oyundaki para birimi",
	"currentPassword": "Mevcut Şifre",
	"current_quest": "Mevcut Görev",
	"current_rank": "Mevcut Seviye",
	"custom_deposit_pending_notification_title": "[AMOUNT] [TOKEN] yatırma işleminiz onay bekliyor.",
	"custom_deposit_success_notification_title": "[AMOUNT] [TOKEN] yatırma işleminiz başarıyla işlendi!",
	"cycling": "Bisiklet",
	"daily": "Günlük",
	"daily_bonus": "Günlük bonus",
	"daily_bonus_text": "Günlük Bonus",
	"daily_bonuses_text": "Günlük Bonuslar",
	"daily_limit": "Günlük çekim limitlerinize ulaştınız. Çekim limitlerinin yenilenmesi için lütfen [TIME] saat sonra tekrar deneyin.",
	"daily_rewards": "Günlük Bonus",
	"daily_rewards_tooltip": "Günlük aktiviteye dayalı bonus. Bakiyenize ve 3 günlük takviminize aktarılır.",
	"daily_slot_tournaments_and_weekly_wheel_drops": "Günlük Turnuvalar & Haftalık Wheel Drop’lar!",
	"daily_slot_tournaments_and_weekly_wheel_drops_description": "25.000 ödül seni bekliyor! Bu hafta 51.400 $’dan payını al!",
	"daily_tournaments": "Günlük Turnuvalar",
	"daily_wins_slots": "Daily Wins Slotları",
	"daily_wins_slots_description": "3,5 M$ Nakit Ödül",
	"darts": "Dart",
	"dashboard": "Kontrol Paneli",
	"dayLabel": "Gün",
	"day_streak": "[DAYS] Günlük Seri",
	"days": "gün",
	"decline": "Reddet",
	"decline_bonus": "Bonusu Reddet",
	"declined": "Reddedildi",
	"dedicated_affiliate_managers": "Özel Affiliate Yöneticileri",
	"dedicated_vip_host_text": "Özel VIP Host",
	"delete": "Sil",
	"demo_play": "Demo Oyna",
	"deposit": "Yatırma",
	"deposit_address": "Yatırma adresi",
	"deposit_bonus": "Yatırma Bonusu",
	"deposit_bonus_accept": "Bonusu Kabul Et",
	"deposit_bonus_accepted": "İlk yatırma işleminizde bir yatırma bonusunu kabul ettiniz",
	"deposit_bonus_decline": "Bonusu Reddet",
	"deposit_bonus_declined": "İlk yatırma işleminizde bir yatırma bonusunu reddettiniz",
	"deposit_bonus_description": "Tatil oyununu güçlendir: Bugün yatırmana %150 Bonus al",
	"deposit_bonus_terms": "Bonus şartlarını gör",
	"deposit_bonus_text": "Bonus",
	"deposit_bonus_title": "Yatırma işlemin geldi",
	"deposit_cash": "Nakit Yatır",
	"deposit_crypto": "Kripto Yatır",
	"deposit_disabled": "Hesabınız şu anda yatırma işlemi yapamaz.",
	"deposit_error_button": "Tamam",
	"deposit_error_subtitle": "Lütfen kısa süre sonra tekrar deneyin.",
	"deposit_error_title": "Şu işlem için yatırma işleminizi işlerken bir sorunla karşılaştık:",
	"deposit_fiat": "Fiat Yatır",
	"deposit_fiat_text": "Sadece Interac ile Fiat yatırma işlemleri için",
	"deposit_first": "Çekim yapabilmek için önce yatırma işlemi yapmalısınız.",
	"deposit_from": "Şuradan yatır:",
	"deposit_meme_coins": "Meme Coin Yatır",
	"deposit_method": "Yatırma yöntemi",
	"deposit_minimum": "Minimum yatırma [MIN_DEPOSIT]",
	"deposit_minimum_wager_within": "Minimum yatırma [MIN_DEPOSIT] | [TIME] içinde [WAGER_AMOUNT] bahis yap",
	"deposit_options": "Yatırma Seçenekleri",
	"deposit_pending_notification_text": "[AMOUNT] [TOKEN] yatırma işleminizi aldık. Onaylandıktan sonra bakiyenize eklenecektir.",
	"deposit_pending_notification_title": "[AMOUNT] [TOKEN] yatırma işleminiz işleniyor ve ağ onayından sonra hesaba yansıtılacaktır.",
	"deposit_success_button": "Tamam",
	"deposit_success_notification_text": "[AMOUNT] [TOKEN] yatırma işleminiz hesabınıza başarıyla geçti. Sorularınız varsa lütfen Destek ile iletişime geçin.",
	"deposit_success_notification_title": "[AMOUNT] [TOKEN] yatırma işleminiz başarılı oldu!",
	"deposit_success_title": "bakiyenize aktarıldı.",
	"deposits": "Yatırmalar",
	"description": "Açıklama",
	"details": "Detaylar",
	"dev_settings": "Geliştirici Ayarları",
	"diamond": "Elmas",
	"dice": "Dice",
	"different_commission_schemes": "Farklı Komisyon Modelleri",
	"disable": "Devre dışı bırak",
	"disable_login_via_wallet": "Cüzdan ile girişi devre dışı bırak",
	"disabled": "DEVRE DIŞI",
	"disclaimer": "Token’ı, yatırma adresini ve ağın seçiminizle eşleştiğini doğrulamak sizin sorumluluğunuzdadır.",
	"disconnect": "Bağlantıyı kes",
	"discover_games": "Oyunları keşfet",
	"display_in_fiat": "Fiat olarak göster",
	"display_name": "Görünen isim",
	"display_name_note": "Görünen isim yalnızca 30 günde bir değiştirilebilir",
	"distribution_day_increase_text": "Dağıtım Günü Artışı",
	"do_not_send_on": "ŞU AĞDA GÖNDERME",
	"do_not_send_to": "Şuraya gönderme",
	"dota": "Dota",
	"double_bet_amount": "Bahis tutarını iki katına çıkar",
	"double_first_deposit_description": "%100 Bonus al & 300$’a kadar ekstra ile oyna",
	"double_first_deposit_first_part_title": "​",
	"double_first_deposit_second_part_title": "İLK YATIRMA İŞLEMİN!",
	"double_first_deposit_title_highlight": "İKİYE KATLA",
	"download_as_csv_file": "CSV Olarak İndir",
	"e_cricket": "E Kriket",
	"earn_cashback_bonuses_description": "Günlük, haftalık ve aylık Cashback bonuslarıyla oynadıkça kazan. Hemen al ve daha fazla ödül ve fırsat için Takvim’ine mutlaka göz at.",
	"earn_rakeback_rewards_description": "VIP seviyeni yükselttikçe artan Rakeback ödülleri kazan! Her bahisle seviye ilerlemesi kaydeder, günlük, haftalık ve aylık daha yüksek ödüller ve daha büyük avantajlara ulaşırsın!",
	"earn_up_to": "Kazan",
	"earn_with": "Flush ile Kazan",
	"earn_with_text": "Casino ve sporda her yönlendirmenin bahislerinden %30’a kadar komisyon al. Komisyon oranı, yönlendirmelerinin tercihlerine bağlıdır:",
	"earnings_potential_with_partners": "[BRAND] Partners ile ne kadar kazanabilirsiniz?",
	"edit": "Düzenle",
	"efighting": "E-Dövüş",
	"ehorse_racing": "eAt Yarışı",
	"email": "E-posta",
	"email_address": "E-posta Adresi",
	"email_not_verified": "Çekime devam edebilmek için e-posta adresinizi doğrulamanız gerekir.",
	"email_preferences": "E-posta Tercihleri",
	"email_required": "Çekim yapabilmek için e-posta adresinizi doğrulamanız gerekir",
	"email_required_for_withdrawal": "çekim yapmak için bir e-posta adresi gereklidir",
	"email_sub_cashier": "Yatırma ve çekim bildirimleri",
	"email_sub_daily": "Günlük teklifler ve promosyonlar",
	"email_sub_monthly": "Aylık Casino Bülteni",
	"email_sub_personalized": "Kişiselleştirilmiş teklifler ve hesap güncellemeleri",
	"email_sub_sportsbook": "Sportsbook haberleri ve güncellemeleri",
	"email_sub_subscribe_all": "Tüm e-posta listelerine abone ol",
	"email_sub_unsubscribe_all": "Tüm e-posta listelerinden çık",
	"email_sub_weekly": "Haftalık özel teklifler ve promosyonlar",
	"emerald": "Zümrüt",
	"empty_personal_notifications_message": "Kişisel bildiriminiz yok.",
	"empty_platform_notifications_message": "Platform bildiriminiz yok.",
	"enable": "Etkinleştir",
	"enable_2fa": "2FA Etkinleştir",
	"enable_2fa_text": "2FA etkin değil",
	"enable_login_via_wallet": "Cüzdan ile girişi etkinleştir",
	"enabled": "Etkin",
	"ended": "Bitti",
	"enter": "Gir",
	"enter_a_campaign_name": "Bir kampanya adı girin",
	"enter_a_referral_code": "Bir referans kodu girin",
	"enter_address": "Çekim yapılacak adresi girin",
	"enter_amount_greater_than_zero": "Lütfen 0’dan büyük bir tutar girin.",
	"enter_now": "Hemen Katıl",
	"enter_valid_number_of_people": "Lütfen geçerli bir kişi sayısı girin.",
	"enter_valid_username": "Lütfen geçerli bir kullanıcı adı girin.",
	"enter_verify": "Ardından 2FA kodunu girin",
	"enter_your_email_address": "e-posta adresinizi girin",
	"equation": "(Bahis Tutarı * Teorik Edge * Affiliate Oranı (% olarak))/2",
	"error": "Hata",
	"error_body": "Yardıma mı ihtiyacınız var? Destek ekibimiz yanınızda. Sabrınız için teşekkürler!",
	"error_creating_rain": "Rain oluşturulurken hata",
	"error_description": "Oyun yüklenirken bir hata oluştu. Sayfayı yenilemeyi veya bağlantınızı kontrol etmeyi deneyin.",
	"error_game_bonus": "Bu oyun seçilen bonus hesabı için kullanılamaz.",
	"error_game_currency": "Bu oyun seçilen para birimi için kullanılamaz.",
	"error_game_geo": "Bu oyun sizin bölgenizde kullanılamaz.",
	"error_game_maintenance": "Bu oyun şu anda bakımda. Lütfen daha sonra tekrar deneyin.",
	"error_game_title": "Oyun kullanılamaz",
	"error_game_unavailable": "Bu oyun şu anda kullanılamaz. Lütfen daha sonra tekrar deneyin.",
	"error_removing_address": "Adres silinirken hata",
	"error_searching_for_player": "Oyuncu aranırken hata",
	"error_title": "Hoppala! Bir şeyler ters gitti.",
	"esports": "Espor",
	"esports_betting": "Espor Bahisleri",
	"esports_live_betting": "Canlı Espor Bahisleri",
	"europe": "Avrupa",
	"every_spin_pays_out": "Her spin ödüyor! Yatırma yok. Kayıp yok. %100 eğlence.",
	"exceeded_maximum_users": "Maksimum kullanıcı sayısı aşıldı",
	"exclusive": "Exclusive",
	"exclusive_affiliate_program": "Özel affiliate programı",
	"exclusive_affiliate_program_text": "Geniş bir kitlen ve çok sayıda takipçin mi var? Partnerimiz ol ve %60’a varan RevShare ile kazanç sağla. Yönlendirdiğin oyuncuların net gelirinden pay al. Hadi başlayalım ve başarıyı birlikte paylaşalım!",
	"exclusive_events_text": "Flush Özel Etkinlikleri",
	"expanded_hero_invite_friends_and_earn_title": "Arkadaşlarını davet et ve kazan",
	"expanded_hero_invite_now_cta": "Hemen davet et!",
	"expanded_hero_up_to_35_percent_commission": "%35'e kadar komisyon",
	"expired": "Süresi doldu",
	"expires": "Süresi doluyor",
	"f1": "Formula 1",
	"failed": "Başarısız",
	"failed_create_update_review": "Yorum oluşturma veya güncelleme başarısız",
	"failed_delete_review": "Yorum silme başarısız",
	"failed_submit_review": "Yorum gönderilemedi. Lütfen tekrar deneyin.",
	"fairness": "Adillik",
	"fairness_and_rng": "Adillik & RNG",
	"faq_about_refer_and_earn_1": "Bonus ile yapılan bahisler komisyona dahil mi?",
	"faq_about_refer_and_earn_1_answer": "Hayır. Yalnızca nakit bahisler yönlendirme bahislerine dahil edilir.",
	"faq_about_refer_and_earn_2": "Sınırsız arkadaş davet edebilir miyim?",
	"faq_about_refer_and_earn_2_answer": "Arkadaşına linkini gönder veya kodunu paylaş; onlar hesap açıp yatırma yapar ve sen de kayıtlarından faydalanırsın.",
	"faq_about_refer_and_earn_3": "Yönlendirdiklerim başkalarını da yönlendirebilir mi?",
	"faq_about_refer_and_earn_3_answer": "Bu, yönlendirdiğiniz kişinin VIP seviyesine bağlıdır. Arkadaşınız seviyesini her yükselttiğinde hesabınıza yeni bir bonus aktarılır:",
	"faq_about_refer_and_earn_4": "Arkadaşım bir şey kazanacak mı?",
	"faq_about_refer_and_earn_4_answer": "Referral programından yalnızca yönlendiren kişi faydalanır.",
	"faq_about_refer_and_earn_5": "Diğer promosyonlara da katılabilir miyim?",
	"faq_about_refer_and_earn_5_answer": "Kesinlikle! Tüm avantajlar, Flush’a kayıtlı tüm oyuncular için geçerlidir.",
	"faq_about_refer_and_earn_6": "Ayda davet edebileceğim maksimum arkadaş sayısı nedir?",
	"faq_about_refer_and_earn_6_answer": "100 arkadaşını başarıyla yönlendirdiğinde Affiliate ekibimiz seninle iletişime geçecektir. Affiliate programı; daha fazla kazanman için özel olarak uyarlanmış ek avantajlar ve özel promosyon kodu teklifleri sunar! Bu avantajları burada görebilirsin: affiliates.flush.com.",
	"faq_about_refer_and_earn_7": "Referral olarak arkadaşlarımı ben de yönlendirebilir miyim?",
	"faq_about_refer_and_earn_7_answer": "Flush’a yönlendirilmiş olsan bile, sen de arkadaşlarını yönlendirebilirsin. Flush’un belirlediği sınırlar içinde kalmak için hizmet şartlarına göz atmayı unutma.",
	"faq_about_refer_and_earn_8": "Komisyon nasıl hesaplanır?",
	"faq_about_refer_and_earn_8_answer": "(Bahis Tutarı * Teorik Edge * Affiliate Oranı (% olarak))/2. Örneğin: %25 wager modeli oranı, Dice’ta 100$ bahis %1 HE = 0,13$ kazanç",
	"faq_referral_dashboard_1": "Bonus bakiye ile yapılan bahisler referral bahislerine dahil olur mu?",
	"faq_referral_dashboard_1_answer": "Hayır, yalnızca gerçek parayla yapılan bahisler referral ödüllerine katkı sağlar.",
	"faq_referral_dashboard_2": "Referral programı nasıl çalışır?",
	"faq_referral_dashboard_2_answer": "Evet! İstediğin kadar yönlendirebilirsin, ancak her ay komisyon için yalnızca en aktif 5 doğrudan yönlendirme sayılır.",
	"faq_referral_dashboard_3": "Referral Programındaki 2.000 $ ödül nasıl çalışır?",
	"faq_referral_dashboard_3_answer": "Evet. Yönlendirdiğin kişi başkalarını davet ettiğinde, Tier 2 ve Tier 3 ödülleri sayesinde onların oyunundan da faydalanırsın.",
	"faq_referral_dashboard_4": "Arkadaşım da ödül alacak mı?",
	"faq_referral_dashboard_4_answer": "Yönlendirme komisyonunu sadece sen kazanırsın. Ancak onlar da kendi arkadaşlarını yönlendirip kazanmaya başlayabilir!",
	"faq_referral_dashboard_5": "Diğer promosyonlara yine de hak kazanır mıyım?",
	"faq_referral_dashboard_5_answer": "Kesinlikle! Referral programı, diğer tüm [BRAND] promosyonlarıyla birlikte çalışır.",
	"faq_referral_dashboard_6": "Ayda davet edebileceğim maksimum arkadaş sayısı nedir?",
	"faq_referral_dashboard_6_answer": "100 arkadaşını başarıyla yönlendirdiğinde Affiliate ekibimiz seninle iletişime geçecektir. Affiliate programı; daha fazla kazanman için özel olarak uyarlanmış ek avantajlar ve özel promosyon kodu teklifleri sunar! Bu avantajları burada görebilirsin: affiliates.[BRAND_DOMAIN].",
	"faq_referral_dashboard_7": "Referral olarak arkadaşlarımı ben de yönlendirebilir miyim?",
	"faq_referral_dashboard_7_answer": "[BRAND]’a yönlendirilmiş olsan bile, sen de arkadaşlarını yönlendirebilirsin. [BRAND]’un belirlediği sınırlar içinde kalmak için hizmet şartlarına göz atmayı unutma.",
	"faq_referral_dashboard_8": "Komisyon nasıl hesaplanır?",
	"faq_referral_dashboard_8_answer": "(Bahis Tutarı * Teorik Edge * Affiliate Oranı (% olarak))/2. Örneğin: %25 wager modeli oranı, Dice’ta 100$ bahis %1 HE = 0,13$ kazanç",
	"fast_efficient_payments": "Hızlı & Verimli Ödemeler",
	"favorite_team": "favori takımını",
	"favorites": "Favoriler",
	"favourite": "Favori",
	"favourite_game": "Favori Oyun",
	"favourite_token_coin": "Favori Token / Coin",
	"feature_buy_in": "Feature Buy-In",
	"feature_buy_in_slots": "Özellik Satın Alımlı Slotlar",
	"feature_temporary_unavailable": "Bu özellik geçici olarak kullanılamıyor gibi görünüyor.",
	"features_text": "Özellikler",
	"fee": "Ücret",
	"fifa": "Fifa",
	"fifteen_per_page": "Sayfa başına 15 öğe",
	"finishes": "Biter",
	"firstNameLabel": "Ad",
	"firstNamePlaceholder": "Adınızı girin",
	"first_name": "Ad",
	"five_per_page": "Sayfa başına 5 öğe",
	"floorball": "Floorball",
	"flush_crypto_casino": "FLUSH KRİPTO CASINO",
	"flush_races": "Flush Races",
	"flush_races_description": "Haftalık 10.000 $ ödül için yarış ve kazanmaya ilerle!",
	"fomo_betby_betslip": "Betslip",
	"fomo_deposit_bonus": "İLK YATIRMA İŞLEMİNİ İKİYE KATLA!",
	"fomo_deposit_bonus_description": "%100 Bonus al & 300$’a kadar ekstra ile oyna",
	"fomo_jackpot_description": "Sadece İzleme—Hayatını Değiştirecek Bir Kazancın Peşine Düş!",
	"fomo_jackpot_first_part_title": "​",
	"fomo_jackpot_second_part_title": "FOMO JACKPOT!",
	"fomo_jackpot_title_highlight": "$1,000,000.00",
	"fomo_limited_cashback": "SINIRLI CASHBACK",
	"fomo_limited_cashback_description": "",
	"fomo_points": "FOMO Points",
	"fomo_points02": "Points",
	"fomo_registration_reward": "ÜCRETSİZ KAYIT ÖDÜLÜ",
	"fomo_registration_reward_description": "",
	"fomo_sidebar_exclusive": "Özel",
	"fomo_sidebar_updown_game": "UpDown Game",
	"fomo_vip_rank_all": "Tüm Seviyeler",
	"fomo_vip_rank_current": "Mevcut",
	"fomo_vip_rank_next": "Sonraki",
	"fomo_vip_rank_play": "Oyna, bir sonraki seviyeye ulaş, ödül al!",
	"fomo_vip_rank_progress": "Sonraki seviye ilerlemesi",
	"fomo_vip_rank_reward": "Sonraki Seviye Yükseltme Ödülü",
	"fomo_vip_rank_title": "VIP Seviyen",
	"fomo_vip_rank_wagering": "Sonraki seviyeye kadar bahis",
	"fomoio_150_welcome": "%150 Hoş Geldin",
	"fomoio_affiliate_agreement": "Bu sözleşme (“Affiliate Sözleşmesi”), siz (“siz” veya “Affiliate”) ile Fomo.io.com tarafından işletilen www.flush.partners arasında yapılmıştır. Fomo.io.com, Curaçao’da kayıtlı, şirket kayıt numarası 161495 olan ve kayıtlı adresi Zuikertuintjeweg Z/N (Zuikertuin Tower) Curaçao olan King of Clubz B.V.’nin bir marka adıdır (“Şirket”). Şirket, çevrimiçi oyun hizmetleri sunmak üzere Gaming Services Provider N.V. lisansı #365/JAZ kapsamında Curaçao’da lisanslıdır. Affiliate Programına kayıt olarak ve pazarlama araçlarımızdan herhangi birini kullanarak veya Affiliate Programımız kapsamında sunulan herhangi bir ödül, bonus ya da komisyonu kabul ederek, bu Affiliate Sözleşmesini okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz.",
	"fomoio_affiliate_managers_details": "Yolculuğun her adımında size rehberlik eden deneyimli affiliate yöneticilerinden oluşan bir ekip.",
	"fomoio_affiliate_marketing_promotion": "Ciddi trafik getirebileceğinizi mi düşünüyorsunuz? O zaman, ve yalnızca o zaman, [BRAND] Partners sizin için uygun olabilir. Bu, yeni başlayanlar veya yarım yamalayan promoterlar için değil. Ancak gerçek oyuncular getirecek kitleye ve becerilere sahipseniz, [BRAND] Net Game Revenue (NGR) gelirinin %50’sine kadar kazanabilirsiniz. Trafik yoksa sonuç da yok — bu kadar basit.",
	"fomoio_affiliate_terms_conditions": "Affiliate Şartlar & Koşullar",
	"fomoio_all_tiers_benefits_description": "Tüm seviyeler benzersiz avantajlar ve artan ödüllerle gelir.",
	"fomoio_and_earn_the_best_rewards_available": "ve mevcut en iyi ödüllerin keyfini çıkar!",
	"fomoio_anniversary_bonus_text": "Yıl Dönümü Bonusu",
	"fomoio_answer_daily_weekly_monthly": "Oyun aktivitesi, seviye ve house edge’e göre — ödüller aktivitenle birlikte artar.",
	"fomoio_answer_how_communicate": "Her ayın 1. günü.",
	"fomoio_answer_how_ofter_bonuses": "Rewards Dashboard’da seviyeni ve o seviyede ulaştığın kilometre taşlarını kontrol et.",
	"fomoio_answer_monthly_bonus": "Tüm bahisler seviye ilerlemesine ve ödüllere dahil olur.",
	"fomoio_answer_vip_club_stand_out": "Günlük, haftalık ve aylık — ödüller her zaman çok yakın.",
	"fomoio_answer_wagering": "Tüm bahisler seviye ilerlemesine ve ödüllere dahil olur.",
	"fomoio_answer_what_are_calendar_distribuition_days": "Her VIP Rank, birkaç kilometre taşı içerir. Yeni bir VIP Rank’a ulaştığınızda veya o Rank içindeki bir kilometre taşına vardığınızda ödül alırsınız. Seviye ne kadar yüksekse, ödüller de o kadar büyüktür. ",
	"fomoio_answer_what_is_cashback": "Bir ödül talep ettiğinizde, ödülün bir kısmı doğrudan bakiyenize eklenir. <br /><br />Diğer kısmı ise Rewards Calendar’ınıza eklenir ve yaklaşan takvim günlerine yayılır. Bu ödül kısmını o Takvim günlerinde talep edebilirsiniz. <br /><br />Her şey çok basit: giriş yapın, Rewards ikonuna tıklayın ve o gün talep edebileceklerinizi görün.",
	"fomoio_answer_what_is_happy_hour": "Cashback, kayıplarınıza göre aldığınız bir ödüldür ve günlük, haftalık ve aylık olarak sunulur. Talep edildikten sonra bunun belirli bir yüzdesi Rewards Calendar’ınıza eklenir.<br /><br />VIP Rank’ınız ne kadar yüksekse, cashback’ler de o kadar büyüktür.",
	"fomoio_answer_what_is_rakeback": "Rakeboost, belirli bir süre boyunca size %15’e kadar EKSTRA Rakeback sağlar. Rewards Dashboard’da süreyi gösteren bir geri sayım görürsünüz. <br /><br />Rakeboost; Günlük/Haftalık/Aylık ödüller, Calendar Rewards ve Rank-Up Rewards gibi diğer ödülleri talep ettiğinizde tetiklenir.<br /><br />Rakeboost’lar birikmez.",
	"fomoio_answer_which_tier_im_on": "Rakeback, kazanıp kaybetmeniz fark etmeksizin yaptığınız tüm bahisler için aldığınız bir ödüldür. <br /><br />Tüm bahislerinizin house edge’i üzerinden yüzde olarak hesaplanır. Formül: (Toplam Bahis × House Edge) × Rakeback %<br /><br />5$+ biriktiğinde talep edilebilir ve belirli bir yüzdesi Rewards Calendar’ınıza eklenir.<br /><br />Yeni VIP rank’lara ulaştıkça rakeback oranı artar!",
	"fomoio_approval_time_for_program": "Onay ne kadar sürer?",
	"fomoio_approval_time_for_program_answer": "Yeni affiliate’ler genellikle kayıttan sonra birkaç iş günü içinde onaylanır.",
	"fomoio_as_you_and_your_friends": "Yönlendirmelerin FOMO’da oynadıkça nakit ödüller kazanırsın. Kazansalar bile!",
	"fomoio_balance": "Bakiyem",
	"fomoio_become_royalty_text": "VIP Ol ve Royal Ayrıcalıkların Tadını Çıkar",
	"fomoio_beginner_affiliate_marketing": "Katılmak için deneyim gerekli mi?",
	"fomoio_beginner_affiliate_marketing_answer": "Hayır. Özel affiliate yöneticilerimiz size rehberlik eder; affiliate pazarlamayı basit ve etkili hale getirir.",
	"fomoio_bitcoin_play_testimonial": "BitcoinPlay olarak Fomo.io Partners’ı üst seviye bir bitcoin casino partneri olarak görüyoruz. Platformları sezgisel tasarım ve kusursuz navigasyon sunarken, destekleyici affiliate ekipleriyle dinamik ve kazançlı bir iş birliği vadediyor.",
	"fomoio_bonus": "Bonus",
	"fomoio_bonus_per_referral": "%35’e kadar referral komisyonu",
	"fomoio_buy_crypto_tooltip": "ℹ️ Bu hizmet üçüncü taraf Onramper tarafından sağlanmaktadır. Kripto Satın Al’a tıklayarak Onramper ödeme hizmetine yönlendirileceksiniz. Hizmetlerini kullanmadan önce Onramper kullanım şartlarını okuyup kabul ediniz. Ödeme ile ilgili sorular için müşteri desteğiyle iletişime geçin. Fomo.io herhangi bir kayıp veya zarardan sorumlu değildir. Kripto para satın alındıktan sonra otomatik olarak Fomo.io cüzdanınıza aktarılır.",
	"fomoio_by_simply_getting": "sadece arkadaşlarını (ve onların arkadaşlarını) FOMO.io’da sana katılmaya davet ederek",
	"fomoio_calculation": "Komisyon Hesaplaması:",
	"fomoio_calendar_claimable_days": "Talep Edilebilir Günler Takvimi",
	"fomoio_calendar_distribution_days_text": "Bonus Dağıtım Günleri",
	"fomoio_calendar_text": "Ödül Takvimi",
	"fomoio_cashback_bonuses02_description": "-",
	"fomoio_cashback_bonuses_description": "Cashback",
	"fomoio_comission_plan": "Komisyon planı:",
	"fomoio_commission": "%35’e kadar Komisyon",
	"fomoio_commission_calculation_details": "Rocketbet Partners Programında komisyonlar nasıl hesaplanır?",
	"fomoio_commission_calculation_details_answer": "Affiliate kazançları, Rocketbet'e yönlendirdikleri oyuncuların aktivitesine, özellikle ürettikleri Net Gaming Revenue (NGR) değerine dayanır. Affiliate'ler, yönlendirdikleri oyuncuların Rocketbet'te ürettiği NGR üzerinden kararlaştırılan komisyon yüzdesini kazanır.",
	"fomoio_commission_from_new_affiliates": "Diğer affiliate’leri yönlendirerek kazanabilir miyim?",
	"fomoio_commission_from_new_affiliates_answer": "Evet. Fomo.io Partners, alt affiliate kazançlarından komisyon kazanabileceğiniz bir Master Affiliate programı sunar.",
	"fomoio_commission_levels_title": "Komisyon seviyeleri:",
	"fomoio_commission_payment_frequency": "Komisyonlar affiliate'lere ne sıklıkla ödenir?",
	"fomoio_commission_payment_frequency_answer": "Affiliate komisyonları her ayın başında hesaplanır ve genellikle önceki ayın geliri için takip eden ayın ilk 10 günü içinde ödenir.",
	"fomoio_commission_plan": "Komisyon Planı",
	"fomoio_commission_schemes_details": "Yönlendirmelerinizin değerini en üst düzeye çıkaran kazançlı komisyon modelleri.",
	"fomoio_company": "Şirket",
	"fomoio_consistent_rewards02_description": "-",
	"fomoio_consistent_rewards_description": "TUTARLI ÖDÜLLER",
	"fomoio_contact_partners": "Rocketbet Partners ile nasıl iletişime geçebilirim?",
	"fomoio_contact_partners_answer": "Ekiple iletişime geçmek için aşağıdaki formu kullanın.",
	"fomoio_contact_us": "Başvurunuzu gönderin",
	"fomoio_crash_and_win_description": "Her gün ilk 60 dakika boyunca Rakeback’ini üçe katla!",
	"fomoio_crypto_casino": "[BRAND] Casino ve Spor Bahisleri",
	"fomoio_crypto_casino_description": "[BRAND], ciddi kazanç potansiyeli için tasarlandı; oyuncu yaşam boyu değerini en üst düzeye çıkaran üst düzey bir elde tutma stratejisiyle desteklenir. Özel mobil deneyim ve güçlü dönüşüm odağıyla, yüksek kaliteli trafiği paraya çeviren bir markadır.",
	"fomoio_custom_vip_bonuses": "Özel VIP Bonusları",
	"fomoio_daily_bonus_text": "Günlük Bonusları Talep Et",
	"fomoio_daily_bonuses_text": "Günlük Bonuslar",
	"fomoio_daily_cashback": "Günlük Cashback.",
	"fomoio_days": "Gün",
	"fomoio_dedicated_affiliate_managers": "Özel affiliate yöneticileri",
	"fomoio_dedicated_vip_host": "Özel VIP Host",
	"fomoio_dedicated_vip_host_text": "Özel VIP Host",
	"fomoio_different_commission_schemes": "Farklı komisyon modelleri",
	"fomoio_distribution_day_increase_text": "Dağıtım Günlerini Artır",
	"fomoio_earn_cashback_bonuses_description": "Kayıplar durumunda nakit ödül al. Günlük, haftalık ve aylık. Seviye yükseldikçe Cashback artar.",
	"fomoio_earn_rakeback_rewards_description": "Yaptığın her bahis için house edge’in belirli bir yüzdesini geri al. Seviye yükseldikçe Rakeback artar.",
	"fomoio_earn_up_to": "Kazan",
	"fomoio_earnings_potential_with_partners": "Ciddi trafik mi? Ciddi para kazanın",
	"fomoio_email_address": "E-posta Adresi",
	"fomoio_enter_your_email_address": "e-posta adresinizi girin",
	"fomoio_equation": "(Bahis Tutarı × Teorik Edge × Affiliate Oranı) / 2",
	"fomoio_exclusive_events_text": "Özel VIP Etkinlikleri",
	"fomoio_exclusive_vip_events": "Özel VIP Etkinlikleri",
	"fomoio_faq_about_refer_and_earn_1": "Bonus bakiye ile yapılan bahisler referral bahislerine dahil olur mu?",
	"fomoio_faq_about_refer_and_earn_1_answer": "Hayır. Yalnızca nakit bahisler referral bahislerine dahil edilir.",
	"fomoio_faq_about_refer_and_earn_2": "Referral programı nasıl çalışır?",
	"fomoio_faq_about_refer_and_earn_2_answer": "Arkadaşına referral linkini veya kodunu gönder. O link veya kodla hesap açarlar, yatırma yapar ve oynarlar. Onların oyunlarından (house edge’e göre) ve onların davet ettiği arkadaşların oyunlarından da ödül kazanırsın.",
	"fomoio_faq_about_refer_and_earn_3": "2.000 $ referral ödülü nasıl çalışır?",
	"fomoio_faq_about_refer_and_earn_3_answer": "Ödülün, yönlendirdiğin kişi VIP seviyelerinde yükseldikçe artar. Her seviye atlamada hesabına yeni bir bonus aktarılır.",
	"fomoio_faq_about_refer_and_earn_4": "Arkadaşım da ödül alacak mı?",
	"fomoio_faq_about_refer_and_earn_4_answer": "Referral programından yalnızca yönlendiren kişi faydalanır. Ancak arkadaşın kendi arkadaşlarını yönlendirip kendi komisyonunu kazanabilir. Bu da senin komisyonunu artırır.",
	"fomoio_faq_about_refer_and_earn_5": "Diğer promosyonlara yine de hak kazanır mıyım?",
	"fomoio_faq_about_refer_and_earn_5_answer": "Kesinlikle! Tüm avantajlar, [BRAND]’ya kayıtlı tüm oyuncular için geçerlidir.",
	"fomoio_faq_about_refer_and_earn_6": "Çok kademeli Refer & Earn programında limit var mı?",
	"fomoio_faq_about_refer_and_earn_6_answer": "Davet edebileceğiniz arkadaş sayısında bir limit yoktur. <br /><br />Uygun yönlendirmelerinizden kazanabileceğiniz referral ödüllerinde de bir limit yoktur. <br /><br />Ancak yalnızca en aktif 5 doğrudan yönlendirmeleriniz ve onların en aktif yönlendirmeleri referral ödülü üretebilir.<br /><br />Yani şu kişilerden ödül alabilirsiniz:<br />En aktif 5 doğrudan yönlendirmeleriniz<br />+ 25 ikincil yönlendirme (en aktif 5 doğrudan yönlendirme × onların en aktif 5 doğrudan yönlendirmesi)<br />+ 125 üçüncül yönlendirme (en aktif 25 ikincil yönlendirme × onların en aktif 5 doğrudan yönlendirmesi)<br /><br />En aktif birincil yönlendirmeleriniz, size üretebilecekleri referral ödülü miktarına göre sıralanır. Hem kendi bahisleri hem de en aktif yönlendirmelerinin bahisleri dikkate alınır.<br /><br />En aktif yönlendirmeleriniz aydan aya değişebilir; bazı eski yönlendirmeler yavaşlarken bazı yeni yönlendirmeler aktivitelerini artırabilir. Amacımız, her zaman en iyi referral ödüllerini almanızı sağlamaktır.",
	"fomoio_faq_about_refer_and_earn_7": "Referral olarak arkadaşlarımı ben de yönlendirebilir miyim?",
	"fomoio_faq_about_refer_and_earn_7_answer": "[BRAND]’ya yönlendirilmiş olsanız bile, siz de arkadaşlarınızı yönlendirebilirsiniz. [BRAND]’nun belirlediği sınırlar içinde kalmak için hizmet şartlarına göz atmayı unutmayın.",
	"fomoio_faq_about_refer_and_earn_8": "Komisyon nasıl hesaplanır?",
	"fomoio_faq_about_refer_and_earn_8_answer": "(Bahis Tutarı x Teorik House Edge ÷ 2) x Komisyon Oranı (% olarak). Örneğin: birincil yönlendirme için %20 komisyon: Dice’ta 100$ bahis, %3 House Edge = 0,30$ kazanç",
	"fomoio_faq_referral_dashboard_1": "Bonus bakiye ile yapılan bahisler referral bahislerine dahil olur mu?",
	"fomoio_faq_referral_dashboard_1_answer": "Hayır. Yalnızca nakit bahisler referral bahislerine dahil edilir.",
	"fomoio_faq_referral_dashboard_2": "Referral programı nasıl çalışır?",
	"fomoio_faq_referral_dashboard_2_answer": "Arkadaşına referral linkini veya kodunu gönder. O link veya kodla hesap açarlar, yatırma yapar ve oynarlar. Onların oyunlarından ve onların davet ettiği arkadaşların oyunlarından da ödül kazanırsın.",
	"fomoio_faq_referral_dashboard_3": "Referral Programındaki 2.000 $ ödül nasıl çalışır?",
	"fomoio_faq_referral_dashboard_3_answer": "Bu, yönlendirdiğiniz kişinin VIP seviyesine bağlıdır. Arkadaşınız seviyesini her yükselttiğinde hesabınıza yeni bir bonus aktarılır:",
	"fomoio_faq_referral_dashboard_4": "Arkadaşım da ödül alacak mı?",
	"fomoio_faq_referral_dashboard_4_answer": "Referral programından yalnızca yönlendiren kişi faydalanır. Ancak arkadaşın kendi arkadaşlarını yönlendirip kendi komisyonunu kazanabilir. Bu da senin komisyonunu artırır.",
	"fomoio_faq_referral_dashboard_5": "Diğer promosyonlara yine de hak kazanır mıyım?",
	"fomoio_faq_referral_dashboard_5_answer": "Kesinlikle! Tüm avantajlar, FOMO’ya kayıtlı tüm oyuncular için geçerlidir.",
	"fomoio_faq_referral_dashboard_6": "Çok kademeli Refer & Earn programında limit var mı?",
	"fomoio_faq_referral_dashboard_6_answer": "Davet edebileceğiniz arkadaş sayısında bir limit yoktur.\n\nUygun yönlendirmelerinizden kazanabileceğiniz referral ödüllerinde de bir limit yoktur.\n\nAncak yalnızca en aktif 5 doğrudan yönlendirmeleriniz ve onların en aktif yönlendirmeleri referral ödülü üretebilir.\n\nYani şu kişilerden ödül alabilirsiniz:\nEn aktif 5 doğrudan yönlendirmeleriniz\n+ 25 ikincil yönlendirme (en aktif 5 doğrudan yönlendirme x onların en aktif 5 doğrudan yönlendirmesi)\n+ 125 üçüncül yönlendirme (en aktif 25 ikincil yönlendirme x  onların en aktif 5 doğrudan yönlendirmesi)\n\nEn aktif birincil yönlendirmeleriniz, size üretebilecekleri referral ödülü miktarına göre sıralanır. Hem kendi bahisleri hem de en aktif yönlendirmelerinin bahisleri dikkate alınır.\n\nEn aktif yönlendirmeleriniz aydan aya değişebilir; bazı eski yönlendirmeler yavaşlarken bazı yeni yönlendirmeler aktivitelerini artırabilir. Amacımız, her zaman en iyi referral ödüllerini almanızı sağlamaktır.",
	"fomoio_faq_referral_dashboard_7": "Referral olarak arkadaşlarımı ben de yönlendirebilir miyim?",
	"fomoio_faq_referral_dashboard_7_answer": "FOMO’ya yönlendirilmiş olsanız bile, siz de arkadaşlarınızı yönlendirebilirsiniz. FOMO’nun belirlediği sınırlar içinde kalmak için hizmet şartlarına göz atmayı unutmayın.",
	"fomoio_faq_referral_dashboard_8": "Komisyon nasıl hesaplanır?",
	"fomoio_faq_referral_dashboard_8_answer": "(Bahis Tutarı x Teorik House Edge ÷ 2) x Komisyon Oranı (% olarak). Örneğin: birincil yönlendirme için %20 komisyon: Dice’ta 100$ bahis %1 House Edge = 0,10$ kazanç",
	"fomoio_fast_efficient_payments": "Hızlı ve verimli ödemeler",
	"fomoio_favorite_games": "Favori oyunlar",
	"fomoio_features_text": "Özel Ayrıcalıklar Seni Bekliyor",
	"fomoio_first_name": "Ad",
	"fomoio_frequently_asked_questions": "Sıkça Sorulan Sorular",
	"fomoio_frequently_asked_questions_text": "VIP Club SSS",
	"fomoio_friends": "Arkadaşlar",
	"fomoio_friends_level": "Seviye",
	"fomoio_games_details": "Yalnızca en iyi casino oyunları ve oyuncuları mutlu eden geniş bir spor bahisleri seçkisi.",
	"fomoio_get_up_to_25": "Yönlendirmelerinin her bahisinden %25’e kadar komisyon alırken, onlar da oyun keyfinin tadını çıkarır.",
	"fomoio_getting_started": "Başlarken",
	"fomoio_high_ngr_increased_revenue": "Yüksek NGR, daha fazla gelir",
	"fomoio_house_edge": "house edge",
	"fomoio_i_want_to_earn_monthly": "AYLIK KAZANMAK İSTİYORUM",
	"fomoio_invite_only_promotions": "Sadece Davetli Promosyonlar",
	"fomoio_invite_referrals": "Yönlendirmeleri davet et",
	"fomoio_invite_your": "Davet et",
	"fomoio_join_now_text": "Şimdi oyna",
	"fomoio_join_vip_club_call_to_action": "VIP Club’a Bugün Katıl!",
	"fomoio_last_name": "Soyad",
	"fomoio_level_up_reward_text": "Level-Up Ödülleri",
	"fomoio_level_up_rewards02_description": "-",
	"fomoio_level_up_rewards_description": "RANK-UP ÖDÜLLERİ",
	"fomoio_level_up_rewards_earnings_description": "Yeni bir VIP Rank kilometre taşına her ulaştığında ödül kazan. Ne kadar yükselirsen, o kadar çok kazanırsın.",
	"fomoio_lifetime_commissions": "Ömür boyu komisyonlar",
	"fomoio_lifetime_commissions_details": "Yönlendirmelerinizden ömür boyu komisyon — düzenli bir gelir kaynağı.",
	"fomoio_like_what_you_see_text": "Neden bekleyesin? Kayıt ol ve bugün VIP Club’a katıl! Yaptığın her bahis seni deneyimini geliştirmek için tasarlanmış gerçekten etkileyici ödüllere bir adım daha yaklaştırır! <br /><br />Özel Rakeback’ten Cashback’e, her Rank daha zengin ödüller getirir! En üst Rank’lar ise ekstra kişiselleştirilmiş ödüller, VIP Host’lar ve daha fazlasını sunar.",
	"fomoio_maximize_playtime_rewards_description": "Ödüller günlük, haftalık ve aylık olarak talep edilebilir — çünkü bunu hak ettin!",
	"fomoio_message": "Mesaj",
	"fomoio_minimum_deposit_tooltip": "⚠️ Minimum yatırma tutarı 0.00000224 BTC’dir. Minimumun altında gönderilen tutarlar fon kaybıyla sonuçlanır. Maksimum yatırma limiti yoktur. Fomo.io BTC yatırma işlemlerinde ücret almaz. Yatırmalar ağ koşulları nedeniyle zaman alabilir.",
	"fomoio_monthly_bonus_text": "Aylık Bonus Ödülleri",
	"fomoio_monthly_bonuses_text": "Aylık Bonuslar",
	"fomoio_monthly_cashback": "Aylık Cashback.",
	"fomoio_more_text": "Fomo.io VIP Club ile daha fazla ayrıcalık keşfet.",
	"fomoio_negative_balances_policy": "Negatif bakiyeler devredilir mi?",
	"fomoio_negative_balances_policy_answer": "Hayır, Rocketbet Partners No Negative Carryover politikasıyla çalışır. Yönlendirilen oyuncular bir ayda negatif NGR üretirse, negatif bakiye sonraki aya devredilmez. Her yeni ay sıfırdan başlar; affiliate'ler önceki negatif bakiyelerin gelecek geliri etkilemeden komisyon kazanmaya devam edebilir.",
	"fomoio_ngr_details": "Yüksek Net Gaming Revenue (NGR) elde eden üst düzey bir marka ve buna bağlı olarak daha yüksek affiliate geliri.",
	"fomoio_partner_review_1": "Fomo.io Partners ile iş birliği yapmak stratejik bir ustalık hamlesiydi. Ekipleri yalnızca kampanyaları yürütmedi; iş hedeflerimize entegre olup, çeyreklik tahminlerimizi yeniden şekillendiren bir büyüme sağladı.",
	"fomoio_partner_review_10": "Fomo.io Partners ile yaptığımız çalışmanın yatırım geri dönüşü net ve ikna ediciydi. Somut değer gösterdiler; iş birliğini son derece akıllı bir iş kararı haline getirdiler.",
	"fomoio_partner_review_11": "Zorluklar ortaya çıktığında Fomo.io ekibi olağanüstü problem çözücüler olduğunu gösterdi. Analitik ve sakin yaklaşımları engelleri optimizasyon fırsatlarına dönüştürdü.",
	"fomoio_partner_review_12": "Fomo.io’daki her bireyin profesyonelliği takdire şayan. Etkileşimler her zaman verimli, saygılı ve ortak hedeflere odaklı.",
	"fomoio_partner_review_13": "Fomo.io sadece hedefleri karşılamıyor; onları yeniden tanımlıyor. Hırsları ve azimleri, kampanyalarımızı daha önce ulaşılamaz sandığımız performans seviyelerine taşıdı.",
	"fomoio_partner_review_14": "Fomo.io Partners’ın sağladığı uzun vadeli stratejik vizyon paha biçilemezdi. Kısa vadeli kampanya sıçramaları değil, sürdürülebilir bir büyüme motoru kurmamıza yardımcı oldular.",
	"fomoio_partner_review_18": "Fomo.io Partners ile çalışmak, bir pazarlama partnerinden beklentilerimizi yukarı taşıdı. Performansları, organizasyonumuz içinde mükemmellik için yeni bir standart belirledi.",
	"fomoio_partner_review_19": "Fomo.io netlik sunar. Raporlamaları, çabaları ile en kritik iş sonuçlarımız arasında kristal netliğinde bir görünürlük sağlar; şüpheye yer bırakmaz.",
	"fomoio_partner_review_2": "Fomo.io Partners ekibindeki sektör bilgisi derinliği inanılmaz. Karmaşık pazar dinamiklerini kolaylıkla yöneterek bize net ve güven veren bir yol haritası sundular.",
	"fomoio_partner_review_20": "Fomo.io ile tüm iş akışı sorunsuz ve verimliydi. İyi tanımlanmış süreçleri ve uzman proje yönetimi, iş birliğini zahmetsiz ve oldukça üretken hale getirdi.",
	"fomoio_partner_review_21": "Fomo.io ile ortaklığımız temel taşı niteliğinde oldu. Sadece anlık sonuçlar sunmadılar; gelecekteki büyüme için sağlam bir çerçeve kurmamıza da yardımcı oldular.",
	"fomoio_partner_review_3": "Abartılı vaatlerin olduğu bir dünyada Fomo.io, sarsılmaz güvenilirliğiyle öne çıkıyor. İddialı hedefler koyuyorlar ve ardından bunları sistematik, şeffaf ve tutarlı şekilde gerçekleştiriyorlar.",
	"fomoio_partner_review_4": "Fomo.io, aklımıza gelmeyen yenilikçi taktikler sundu. Yaratıcı ve veriye dayalı yaklaşımları pazardaki gürültüyü aşıp olağanüstü etkileşim getirdi.",
	"fomoio_partner_review_5": "Bu, müşteri-tedarikçi ilişkisinden çok stratejik bir ittifak gibiydi. Fomo.io Partners başarımıza gerçekten yatırım yaptı; kendi ekibimizin gerçek bir uzantısı gibi hareket etti.",
	"fomoio_partner_review_6": "Fomo.io’nun temel iş metriklerimize odaklanması ferahlatıcıydı. Her strateji, kârlılığımız açısından gerçekten önemli olan noktada etki yaratmaya bağlıydı.",
	"fomoio_partner_review_7": "Fomo.io Partners ekibinin şeffaflığı büyük bir güven oluşturdu. Net raporlama ve proaktif iletişimle hiçbir zaman belirsizlik yaşamadık.",
	"fomoio_partner_review_8": "Pazar dinamik ve Fomo.io da öyle. Stratejileri gerçek zamanlı hızla uyarlayıp optimize etme yetenekleri, olası zorlukları en büyük kazanımlarımıza dönüştürdü.",
	"fomoio_partner_review_9": "Fomo.io’nun uygulaması kusursuz. Detaylara verdikleri önem ve kaliteye bağlılıkları; her varlıkta, her lansmanda ve her kampanya raporunda kendini gösteriyor.",
	"fomoio_partner_testimonials": "Partnerlerimiz Ne Diyor",
	"fomoio_partners_perks": "Herkesi kabul etmiyoruz. Talebinizi ve teklifinizi gönderin — uygun görülürseniz şu avantajları alırsınız:",
	"fomoio_partners_program": "[BRAND] ORTAKLIK PROGRAMI",
	"fomoio_partners_program_overview": "Rocketbet Partners Programı nedir?",
	"fomoio_partners_program_overview_answer": "Rocketbet Partners, Rocketbet'in resmi affiliate programıdır. Affiliate'ler, yayıncılar, topluluklar ve medya ortakları, oyuncuları Rocketbet'e yönlendirerek trafiğini gelire dönüştürebilir ve uzun vadeli oyuncu aktivitesiyle rekabetçi komisyonlar kazanabilir.",
	"fomoio_payment_details": "Nakit veya kripto — her ayın ilk günlerinde hızlı ve verimli ödemeler.",
	"fomoio_play_crypto_testimonial": "Fomo.io Partners ile çalışmak bir keyif; affiliate ekipleri her zaman yanıt vermeye ve sorulara yardımcı olmaya istekli. En önemlisi, Fomo.io kripto trafiğimiz için ideal, harika bir kripto casino.",
	"fomoio_potencial_questions": "Soruların yanıtlandı.",
	"fomoio_program_working_details": "Rocketbet Partners Programı nasıl çalışır?",
	"fomoio_program_working_details_answer": "Yeni affiliate'ler doğrudan Rocketbet Partners platformu üzerinden kayıt olabilir. Onay sonrası atanan bir Affiliate Manager hesap kurulumunda yardımcı olur ve promosyon, takip veya kampanyalarla ilgili soruları yanıtlar. Hesap aktif olduğunda affiliate'ler kişisel yönlendirme linki ve kodunu alır; bunları oyuncularla paylaşabilirler. Bu yönlendirmelerle kayıt olup oynayan uygun her oyuncu affiliate için komisyon üretir.",
	"fomoio_promotion_restrictions": "Rocketbet yönlendirme linkimi tanıtırken kısıtlama var mı?",
	"fomoio_promotion_restrictions_answer": "Hiçbir koşulda Rocketbet veya ilişkili markalar reşit olmayanlara veya kumarla ilgili sorunları olan hassas kişilere tanıtılamaz. Affiliate'lerin kısıtlı yargı bölgelerini hedeflemesi, yanıltıcı reklam uygulamaları veya izinsiz korumalı marka anahtar kelimelerine teklif vermesi de yasaktır. Tüm detaylar için Rocketbet Partners Şartlar ve Koşulları incelenmelidir.",
	"fomoio_promotional_materials_provided": "Rocketbet affiliate'lerine hangi promosyon materyallerini sağlar?",
	"fomoio_promotional_materials_provided_answer": "Rocketbet Partners, performansı maksimize etmek için banner, logo, landing page, bonus teklifleri, yönlendirme linkleri ve affiliate kampanyalarına özel diğer promosyon içeriklerini içeren geniş pazarlama araçları sunar.",
	"fomoio_promotions_details": "Cashback’ten free spin’lere ve turnuvalara kadar düzenli promosyonlar; dönüşümü artırır ve oyuncuları memnun eder.",
	"fomoio_question_daily_weekly_monthly": "Ödüllerim Neler?",
	"fomoio_question_how_communicate": "Aylık Bonus Ne Zaman Planlanıyor?",
	"fomoio_question_how_ofter_bonuses": "VIP Rank’ımı Nasıl Kontrol Edebilirim?",
	"fomoio_question_monthly_bonus": "Wagering Nasıl Hesaplanır?",
	"fomoio_question_vip_club_stand_out": "Ödülleri Ne Sıklıkla Alırım?",
	"fomoio_question_wagering": "Wagering Nasıl Hesaplanır?",
	"fomoio_question_what_are_calendar_distribuition_days": "Rank-Up Ödülleri Nedir?",
	"fomoio_question_what_is_cashback": "Calendar Rewards Nedir?",
	"fomoio_question_what_is_happy_hour": "Cashback Nedir?",
	"fomoio_question_what_is_rakeback": "Rakeboost Nedir?",
	"fomoio_question_which_tier_im_on": "Rakeback Nedir?",
	"fomoio_races": "Fomo.io Races",
	"fomoio_races_description": "Her gün ilk 60 dakika boyunca Rakeback’ini üçe katla!",
	"fomoio_raise_your_game_and_stay": "Günlük Ödüllerle Oyunda Kal",
	"fomoio_rakeback": "Rakeback",
	"fomoio_rakeback_perks02_description": "-",
	"fomoio_rakeback_perks_description": "Rakeback",
	"fomoio_rakeback_text": "Rakeback Ödülleri",
	"fomoio_rakeboost": "Rakeboost",
	"fomoio_rakeboost_description": "Her gün ilk 60 dakika boyunca Rakeback’ini üçe katla!",
	"fomoio_rakeboost_happy_hour02_description": "-",
	"fomoio_rakeboost_happy_hour_description": "RAKEBOOST",
	"fomoio_rakeboost_text": "Rakeboost Bonusları",
	"fomoio_ready_to_text": "Ödüllerini Maksimize Etmeye Hazır mısın?",
	"fomoio_real_time_affiliate_data": "Gerçek zamanlı affiliate verileri",
	"fomoio_refer_and_earn": "Fomo.io ile Refer & Earn!",
	"fomoio_refer_and_earn_description": "Yeni casino üyelerinden kazanmaya başla",
	"fomoio_refer_new_users_to_get": "Arkadaşlarını davet et ve kazan:",
	"fomoio_refer_now": "Şimdi yönlendir!",
	"fomoio_referral_commission_desc": "Yönlendirmelerin (veya onların yönlendirmeleri) bahis yaptığında komisyon kazanırsın — kazansalar bile!",
	"fomoio_referral_commission_rewards": "Referral Komisyon Ödülleri:",
	"fomoio_referral_faqs_title": "SSS",
	"fomoio_referral_limit_details": "Rocketbet'e kaç yönlendirme getirebileceğim konusunda bir limit var mı?",
	"fomoio_referral_limit_details_answer": "Hayır. Bir affiliate'in Rocketbet'e yönlendirebileceği oyuncu sayısında limit yoktur. Affiliate ne kadar çok aktif oyuncu getirirse, uzun vadeli komisyon potansiyeli o kadar güçlü ve istikrarlı olur.",
	"fomoio_referral_rules_added_to_your_balance": "Komisyonun %20’si doğrudan bakiyene eklenir, kalan kısmı Rewards calendar’ına eklenir ve 7 güne yayılır.",
	"fomoio_referral_rules_period": "Referral komisyonları, bir önceki ay yönlendirmelerinin aktiviteleri için ayda bir kez aktarılır.",
	"fomoio_referral_rules_primary_description": "Doğrudan yönlendirdiğin oyunculardan %20 komisyon kazanırsın.",
	"fomoio_referral_rules_primary_referrals": "Birincil yönlendirmeler",
	"fomoio_referral_rules_secondary_description": "Birincil yönlendirmelerinin davet ettiği oyunculardan %10 komisyon kazanırsın.",
	"fomoio_referral_rules_secondary_referrals": "İkincil yönlendirmeler",
	"fomoio_referral_rules_tertiary_description": "İkincil yönlendirmelerinin davet ettiği oyunculardan %5 komisyon kazanırsın.",
	"fomoio_referral_rules_tertiary_referrals": "Üçüncül yönlendirmeler",
	"fomoio_referral_rules_tier1": "Tier 1",
	"fomoio_referral_rules_tier2": "Tier 2",
	"fomoio_referral_rules_tier3": "Tier 3",
	"fomoio_referral_rules_you_earn": "Arkadaşların (veya onların arkadaşları) bahis yaptığında komisyon kazanırsın. Kazansalar bile!",
	"fomoio_referral_tracking_details": "Yönlendirmelerimi ve komisyonlarımı takip edebilir miyim?",
	"fomoio_referral_tracking_details_answer": "Evet. Rocketbet Partners, affiliate'lere performans ve istatistikleri gerçek zamanlı takip edebilecekleri profesyonel bir platform sunar. Kayıtlar, yatırımlar, oyuncu aktivitesi, gelir, komisyonlar ve diğer önemli metrikler doğrudan affiliate panelinden izlenebilir.",
	"fomoio_referrals": "yönlendirmelerinin VE onların yönlendirmelerinin yaptığı bahislerin",
	"fomoio_referrers_bonus": "Bonus",
	"fomoio_regular_promotions": "Düzenli promosyonlar",
	"fomoio_reporting_details": "Optimizasyon ve takip için gerçek zamanlı istatistik raporları.",
	"fomoio_rewards_and_cashback_description": "Seviyeleri tırmandıkça özel ödüller ve cashback’in kilidini aç.",
	"fomoio_rewards_increase": "Ödüller Artar",
	"fomoio_rewards_text": "Özel Ödüller Seni Bekliyor",
	"fomoio_self_family_referral_policy": "Kendimi veya aile üyelerimi yönlendirebilir miyim?",
	"fomoio_self_family_referral_policy_answer": "Hayır. Program bütünlüğünü korumak için self-referral ve aile üyelerinin yönlendirilmesine izin verilmez.",
	"fomoio_sign_up_text": "Kayıt Ol",
	"fomoio_sign_up_today_call_to_action": "Bugün kayıt ol ve ayrıcalıklarla döşenmiş bir yolu keşfet! Özel Rakeback’ten Cashback’e, her level up daha zengin ödüller getirir! Günlük, haftalık ve aylık bonuslar için sıralamalarda yüksel — sadakatin sana daha fazlasını kazandırır.",
	"fomoio_sportsbook_description": "Futbol, Basketbol, Esports ve daha fazlasına bahis yap",
	"fomoio_start_earning_today": "Nasıl çalışır",
	"fomoio_start_inviting_your_friends": "Arkadaşlarını Davet Etmeye Başla",
	"fomoio_start_playing_with": "Şununla oynamaya başla:",
	"fomoio_start_playing_with_description": "Kayıt ol, casino oynamaya başla ve %150 hoş geldin bonusunu al",
	"fomoio_step_1_description": "Kayıt ol, ilk yatırmanı yap ve VIP Club’a katılmak için oynamaya başla.",
	"fomoio_step_1_text": "ADIM 1",
	"fomoio_step_2_description": "VIP rank’larında yükselmek için favori oyunlarına veya spora bahis yap.",
	"fomoio_step_2_text": "ADIM 2",
	"fomoio_step_3_description": "Günlük, haftalık ve aylık ödüllerin kilidini aç. Ne kadar oynarsan, o kadar çok ödül kazanırsın.",
	"fomoio_step_3_text": "ADIM 3",
	"fomoio_strategies_to_increase_earnings": "Kazançlarımı nasıl artırabilirim?",
	"fomoio_strategies_to_increase_earnings_answer": "Yönlendirme hacmini artır, bonus tekliflerini öne çıkar ve landing page’lerini optimize et. Affiliate ekibimiz başarı için stratejileri uyarlamana yardımcı olur.",
	"fomoio_submit": "Gönder",
	"fomoio_support_details": "İngilizce, Almanca, Japonca, Arapça ve Fransızca dahil birden fazla dilde affiliate desteği.",
	"fomoio_support_in_multiple_languages": "Çok dilli destek",
	"fomoio_tailored_reload_bonuses_text": "VIP’ler için Özel Reload Bonusları",
	"fomoio_testimonial_1_text": "Fomo.io VIP, tüm oyun deneyimimi gerçekten dönüştürdü. Platform, her ziyareti unutulmaz kılan çekici promosyonlarla birlikte heyecan verici bir oyun çeşitliliği sunuyor. Yatırma ve çekim süreçlerinin ne kadar sorunsuz olduğuna bayılıyorum—hızlı ve zahmetsiz. İster yeni başlayın ister deneyimli olun, Fomo.io VIP’nin kullanıcı dostu arayüzü ve son teknoloji özellikleri gerçekten öne çıkıyor!",
	"fomoio_testimonial_2_text": "Fomo.io VIP’nin eşsiz ödüllerinden inanılmaz memnunum. Sadece düzenli olarak cömert bonuslar almakla kalmıyorum, destek ekibi de her konuda hızla çözüm üreterek beklentinin ötesine geçiyor. Samimi ve profesyonel yaklaşımları, her adımda kendinizi değerli hissettiriyor. Bu ayrıcalıklar sayesinde oyun deneyimim ciddi şekilde iyileşti—kesinlikle tavsiye ediyorum!",
	"fomoio_testimonial_3_text": "Fomo.io VIP’nin günlük ödülleri beni gün be gün geri getiriyor. Her yeni teklif, bankroll’uma taze bir destek gibi geliyor ve bu ödüllerin ne kadar hızlı biriktiğini görmek inanılmaz motive edici. Platformun şık tasarımı ve geniş oyun yelpazesi genel olarak çok keyifli bir deneyim sunuyor. Asla sıkılmıyorum, anında çekimler ise üstüne kaymak!",
	"fomoio_testimonial_4_text": "Happy Hour Rakeback, Fomo.io VIP’de açık ara favori özelliğim. O özel saatlerde ekstra cashback kazanmak, seanslarıma bambaşka bir heyecan katıyor. Kazancı maksimize etmek ve oyun süresini uzatmak için harika bir yol; üstelik bütçeyi zorlamadan. Sitenin kusursuz desteği ve genel güvenilirliğiyle birleşince, Fomo.io VIP’nin üstüne tanımak zor!",
	"fomoio_testimonials_text": "VIP’lerimizden Dinleyin",
	"fomoio_thousands_of_casino_games": "En iyi oyunlar ve en iyi oranlar",
	"fomoio_tier_name_text": "VIP Seviye",
	"fomoio_total_level_up_rewards": "Toplam Rank-Up Ödülleri",
	"fomoio_total_level_up_rewards_text": "Toplam Level-Up Ödülleri",
	"fomoio_total_wager": "Toplam bahis",
	"fomoio_triple_rakeback_description": "Diğer ödüllerini talep ettiğinde %15’e kadar EKSTRA rakeback tetikle.",
	"fomoio_unlocking": "Referral Ödül Kuralları:",
	"fomoio_unlocking_rules": "Referral Ödül Kuralları",
	"fomoio_view_vip_level_details_text": "Mevcut Seviyenin Detaylarını Görüntüle",
	"fomoio_vip_benefits_text": "Ayrıcalıklar Hakkında",
	"fomoio_vip_club_description": "Her yerdekinden daha fazla VIP CLUB ödülü ve cashback",
	"fomoio_vip_club_text": "Rakeback, cashback ve daha fazlası gibi premium avantajlarla ödüllendirici 11 seviyeli bir sistemi keşfet.<br /> Tamamı nakit — çevrim şartı yok!",
	"fomoio_vip_desc": "ne kadar kazanabileceğin hakkında",
	"fomoio_vip_faqs": "SSS",
	"fomoio_vip_level": "maksimum limit yok",
	"fomoio_vip_rank_rewards": "Seviyeye Göre VIP Ödülleri",
	"fomoio_vip_rewards": "VIP Ödülleri",
	"fomoio_vip_subtitle01": "Dünya standartlarında bir VIP deneyiminin keyfini çıkar",
	"fomoio_vip_subtitle02": "FOMO’nun VIP Club’ına Hoş Geldin",
	"fomoio_vip_testimonials_text": "VIP Üyelerden Yorumlar",
	"fomoio_vip_title01": "FOMO’nun VIP Club’ına Hoş Geldin",
	"fomoio_vip_title02": "Özel Ayrıcalıklar Seni Bekliyor!",
	"fomoio_wager_required": "Gerekli Kâr",
	"fomoio_wager_requirements": "Çevrim Gereksinimleri",
	"fomoio_wagering_required": "Çevrim Gerekli.",
	"fomoio_want_to_be_affiliate": "Hâlâ soruların mı var? Bugün Fomo.io Partners’a katıl.",
	"fomoio_weekly_bonus_text": "Haftalık Bonus Ödülleri",
	"fomoio_weekly_bonuses_text": "Haftalık Bonuslar",
	"fomoio_weekly_cashback": "Haftalık Cashback.",
	"fomoio_welcome_bonus_text": "Zaten Fomo.io’nun bir parçasısın! Arkadaşlarını katılmaları için davet et; onlar da cömert bir hoş geldin bonusu alacak.",
	"fomoio_welcome_message": "Ve sıralamalarda yükseldikçe ödüller daha da iyileşir.<br /> Sadakatin zenginliğe dönüştüğü tek yer: FOMO!",
	"fomoio_welcome_to_the_pinnacle": "En Üst Seviyeye Hoş Geldin",
	"fomoio_welcome_to_vip_club_text": "Fomo.io VIP Club’a Hoş Geldin",
	"fomoio_why_choose_partners": "[BRAND] Partners onayını nasıl alırım?",
	"fomoio_with_rewards": "Özel VIP Ödüllerinin Keyfini Çıkar",
	"fomoio_you_25_comission": "Komisyonun şuna göre belirlenir:",
	"fomoio_you_can_earn": "Hem sen hem de arkadaşların için en iyi referral programını kaçırma. Dahası,",
	"fomoio_your_bonuses_unlocked": "Arkadaşlarının toplam bahisleri arttıkça referral bonuslarının kilidini aç. Ödüller doğrudan bakiyene nakit olarak aktarılır. Kısıtlama yok, çevrim şartı yok.",
	"football": "Futbol",
	"footer_text": "Hizmet, Kosta Rika’da 3-102-897031 şirket kayıt numarasıyla kayıtlı, kayıtlı adresi PROVINCE 01 SAN JOSE, CANTON 02 ESCAZU, SAN RAFAEL, REPUBLIC OF COSTA RICA olan INNOVA PENSAR LIMITED Liability Company. tarafından işletilmektedir. Canadian Tobique First Nation kapsamında lisanslıdır.",
	"footer_text_flush": "Flush.com, Kosta Rika’da 3102928865 şirket kayıt numarasıyla kayıtlı, kayıtlı adresi: San Pedro, Barrio Dent, Costa Rican North American Center, Office 3 olan Fordegens Limitada tarafından işletilmektedir. Flush.com, Komorlar Birliği’ne bağlı Anjouan Özerk Adası Hükümeti tarafından lisanslanmış ve düzenlenmektedir ve ALSI-202509008-FI1 Lisans No. ile faaliyet göstermektedir. Flush.com, tüm düzenleyici uyumluluk kontrollerini geçmiştir ve her türlü şans oyunları ve bahis faaliyetlerini yürütmek üzere yasal olarak yetkilendirilmiştir.",
	"forfeit_bonus": "Bonustan Feragat Et",
	"free": "Ücretsiz",
	"free_guaranteed_wins": "10 Garantili Ücretsiz Kazanç",
	"free_spins_and_bonus_spins": "Free Spins ve Bonus Spins",
	"freebets_modal_choose_slot": "Asagidan bir slot secin ve cevirmeye baslayin.",
	"freebets_modal_no_deposit_needed": "Yatirim gerekmez.",
	"freebets_modal_title": "10 UCRETSIZ SPIN",
	"freebets_modal_win_real_prizes": "Gercek oduller kazanin.",
	"freespins": "Free Spins",
	"frequently_asked_questions": "Sıkça sorulan sorular",
	"frequently_asked_questions_text": "Sıkça Sorulan Sorular",
	"friends": "Arkadaşlar",
	"friends_level": "Arkadaş Seviyesi",
	"front": "ÖN",
	"full_screen": "Tam Ekran",
	"futsal": "Futsal",
	"gamble_aware": "Gamble Aware",
	"game": "Oyun",
	"game_info_not_available": "Oyun bilgisi mevcut değil",
	"game_providers": "Oyun Sağlayıcıları",
	"game_review_theme": "Oyun İnceleme Teması",
	"game_shows": "Oyun Şovları",
	"games": "Oyunlar",
	"games_details": "Oyuncuları memnun etmek için, orijinal oyunlar ve kripto hodler’ların favorileri dahil binlerce casino oyunu.",
	"gaming_license_norms_text": "Oyun lisansı kuralları gereği, bölgenizden oyuncu kabul edemiyoruz! Seyahat ederken çevrimiçi güvenliğinizi sağlamak için VPN kullanmanız önerilir. Daha fazla yardım için <a class='email-link' href='mailto:{SUPPORT_EMAIL}' style='{SUPPORT_EMAIL_STYLES}'>{SUPPORT_EMAIL}</a> ile iletişime geçin!",
	"gaming_license_norms_text_mobile": "Oyun lisansı kuralları gereği, bölgenizden oyuncu kabul edemiyoruz! Seyahat ederken çevrimiçi güvenliğinizi sağlamak için VPN kullanmanız önerilir. Daha fazla yardım için <a class='email-link' href='mailto:{SUPPORT_EMAIL}' style='{SUPPORT_EMAIL_STYLES}'>{SUPPORT_EMAIL}</a> ile iletişime geçin!",
	"general": "Genel",
	"generated_reward": "Oluşturulan Ödül",
	"get": "al",
	"get_started": "Başla",
	"get_up_to_25": "Yönlendirmelerinin her bahisinden, oyun seçimimizin keyfini çıkarırken %25’e kadar komisyon al.",
	"get_your": "Al",
	"get_your_cash_back": "Cashback’ini al",
	"get_your_deposit_bonus": "Yatırma bonusunu al",
	"getting_started": "Başlarken",
	"global_sports_premium_odds": "Küresel sporlar premium oranlar",
	"go_to_races": "Races’a Git",
	"go_to_slots": "Slotlara Git",
	"go_to_sports": "Spor’a Git",
	"go_to_vip": "VIP’e Git",
	"go_vip": "VIP Ol",
	"gold": "Altın",
	"golf": "Golf",
	"googleAuth": "Google Kimlik Doğrulama",
	"googleAuthDisabled": "PASİF",
	"googleAuthEnabled": "AKTİF",
	"great_to_have_you_back": "Seni tekrar aramızda görmek harika! Günlük bonuslarını talep ettin mi? [BRAND]’de her zaman daha fazla eğlence var!",
	"half_bet_amount": "Bahis tutarının yarısı",
	"handball": "Hentbol",
	"hash_round": "Tur Hash’i",
	"hashed_server_seed": "Hashlenmiş Server Seed",
	"hello": "Merhaba",
	"help": "Yardım",
	"help_center": "Yardım Merkezi",
	"helpdesk": "Yardım Masası",
	"hidden": "Gizli",
	"hide": "Gizle",
	"hide_profit": "Toplam kârını gizle",
	"hide_progress": "İlerlemeyi gizle",
	"hide_stats": "Bahis istatistiklerini gizle",
	"hide_wagered": "Toplam bahisini gizle",
	"hide_zero_balances": "0 bakiyeleri gizle",
	"high_ngr_increased_revenue": "Yüksek NGR ile Artan Gelir",
	"high_rollers": "High Rollers",
	"hilo": "Hi-Lo",
	"history": "Geçmiş",
	"hit_rate": "İsabet Oranı",
	"hockey": "Hokey",
	"hold": "Beklet",
	"home_welcome": "Hoş geldin",
	"homepage": "Ana Sayfa",
	"homepage_alt4_banner02_casino": "Casino",
	"homepage_alt4_banner02_casino_desc_line1": "Browse through",
	"homepage_alt4_banner02_casino_desc_line2": "thousand of games",
	"homepage_alt4_banner02_jump_in": "Jump in →",
	"homepage_alt4_banner02_sport": "Sport",
	"homepage_alt4_banner02_sport_betting": "Sport Betting",
	"homepage_alt4_banner02_sport_desc_line1": "Support your",
	"homepage_alt4_banner02_sport_desc_line2": "favorite team",
	"hot_promos": "Popüler Promolar",
	"hotkeys": "Kısayol Tuşları",
	"hotkeys_enabled": "Kısayol tuşları etkin",
	"house_edge": "house edge",
	"how_it_works": "Nasıl çalışır?",
	"how_it_works_referral_bonus": "Referans bonusu",
	"how_it_works_referral_bonus_description": "Arkadaşlarınızı kendi yolculuklarına başlamaya davet ederek daha fazla ödül kazanın! Bahislerinden %35'e kadar komisyon alırsınız. Kazansınlar ya da kaybetsinler!",
	"huge_jackpot": "BÜYÜK JACKPOT",
	"i_accept": "Kabul Ediyorum",
	"i_agree": "Kabul Ediyorum",
	"i_confirm_enabling_signin_to_brand_with_this_wallet": "[BRAND] için bu cüzdanla girişin etkinleştirilmesini onaylıyorum",
	"i_want_a_deposit_bonus": "{bonus} istiyorum",
	"i_want_to_earn_monthly": "AYLIK KAZANMAK İSTİYORUM",
	"ice_hockey": "Buz Hokeyi",
	"in_progress": "Devam ediyor",
	"inactive": "Pasif",
	"info_card_description_1": "Flush Haftalık Races başladı: Spin at, bahis yap ve liderlik tablosunda yüksel.",
	"info_card_description_2": "Ne kadar çok oynarsan, o kadar üst sıralara çıkarsın!",
	"info_card_description_3": "Her hafta büyük nakit ödüller seni bekliyor.",
	"info_card_description_4": "Zirveyi hedefle; her spin sayılır. Hemen başla!",
	"info_card_footer_1": "İzini bırakmaya hazır mısın?",
	"info_card_footer_2": "Oynat’a bas ve nelerden yapıldığını herkese göster. Kaderin Flush Haftalık Races Challenge’da seni bekliyor!",
	"info_card_title_part_1": "🏁 Aksiyona katıl:",
	"info_card_title_part_2": "Flush’un 10.000 $’lık Haftalık Races Challenge’ı! 🏆",
	"instructions": "Level 1 doğrulamasını tamamlamak için lütfen aşağıdaki bilgileri doldurun:",
	"insufficient_funds": "Girdiğiniz tutar mevcut bakiyenizi aşıyor. Lütfen daha düşük bir tutar girin.",
	"invalid_address_type": "Geçersiz Adres Türü, Beklenen",
	"invalid_address_type_description": "Adres türü bu ağ için desteklenmiyor.",
	"invalid_amount": "Geçersiz Tutar",
	"invalid_number_of_people": "Geçersiz Kişi Sayısı",
	"invite_new_users_and_get_commission": "Yeni Kullanıcıları Davet Et ve Bahislerinden %35’e Kadar Komisyon Al. Kazansalar Bile!",
	"invite_new_users_to_get": "Yeni kullanıcıları davet et ve kazan:",
	"invite_referrals": "Yönlendirmeleri davet et",
	"invite_your": "Davet et",
	"invite_your_friends_banner_description": "Arkadaşlarını davet et ve <span class='yellow-text'>Flush.com</span> heyecanını keşfetmelerine yardımcı olduğun için ödüllendir",
	"iron": "Demir",
	"item": "öğe",
	"jackpot": "$1,000,000.00 FOMO JACKPOT!",
	"jackpot_description": "Sadece izleme—hayatını değiştirecek bir kazancın peşine düş!",
	"jackpot_main": "Ana Jackpot",
	"jackpot_medium": "Orta Jackpot",
	"jackpot_small": "Küçük Jackpot",
	"jackpot_subtitle": "Sadece İzleme—Hayatını Değiştirecek Bir Kazancın Peşine Düş!",
	"jackpot_title": "FOMO JACKPOT!",
	"jelly_express_daily_tournaments": "Jelly Express Daily Tournaments",
	"join_now": "Şimdi Katıl",
	"join_now_text": "Şimdi katıl",
	"join_the_vip_club": "VIP Club’a Katıl",
	"join_vip_club_call_to_action": "VIP Club!",
	"join_vip_club_description": "Rakeback, Cashback ve Daha Fazlasının Tadını Çıkar",
	"join_vip_club_first_part_title": "KATIL",
	"join_vip_club_second_part_title": " ",
	"join_vip_club_title_highlight": "VIP CLUB",
	"joined_on": "Katılma Tarihi",
	"jump_in": "Hemen başla →",
	"keno": "Keno",
	"kyc_policy": "KYC Politikası",
	"language": "DİL",
	"language_privacy": "Dil",
	"lastNameLabel": "Soyad",
	"lastNamePlaceholder": "Soyadınızı girin",
	"last_name": "Soyad",
	"latest_bets": "Son Bahisler",
	"launch_to_riches": "LAUNCH TO RICHES",
	"launch_to_riches_description": "Fırlat, ya da yerde\nkal!",
	"le_bunny_description": "Trigger the bonus.\nOr wonder when it would have...",
	"le_bunny_title": "Le Bunny",
	"le_digger": "LE DIGGER",
	"le_digger_description": "İyi şeyler\n uzun süre\ngömülü kalmaz",
	"league_of_legends": "League Of Legends",
	"learn_more": "Daha fazla bilgi",
	"learn_more_label": "Kendini Dışlama hakkında daha fazla bilgi",
	"learn_more_tooltip_content": "Cooldown süresi sona erdiğinde, kendini dışlama sürecini nasıl tamamlayacağınıza dair detaylı talimatları içeren bir takip e-postası alacaksınız.",
	"level_up_reward_text": "Level Up Ödülü",
	"level_up_rewards_description": "Level Up Ödülleri",
	"level_up_rewards_earnings_description": "Yaşasın! Sıkı çalışman karşılığını veriyor! Bir sonraki seviyeye ulaştığında ekstra bir nakit bonusla ödüllendirilirsin! Düzenli oynayıp oyunların keyfini çıkararak 1.700.000 $'a kadar ödül kazan!",
	"level_up_tooltip": "Yeni VIP seviyelerine ulaştığında verilen tek seferlik ödüller. Bakiyene ve 20 günlük takvimine aktarılır.",
	"lifetime_commissions": "Ömür Boyu Komisyonlar",
	"lifetime_commissions_details": "Yönlendirmelerinizden ömür boyu komisyon; düzenli bir gelir kaynağı sağlar.",
	"like": "Beğen",
	"like_what_you_see_text": "Beğendin mi? Katıl:",
	"limit_daily": "Günlük limit",
	"limit_daily_remaining": "Kalan günlük limit",
	"limit_monthly": "Aylık limit",
	"limit_monthly_remaining": "Kalan aylık limit",
	"limit_weekly": "Haftalık limit",
	"limit_weekly_remaining": "Kalan haftalık limit",
	"live": "Canlı",
	"live_baccarat": "Canlı Bakara",
	"live_bets": "Canlı Bahis",
	"live_bitcoin_betting": "Canlı Bitcoin Bahisleri",
	"live_blackjack": "Canlı Blackjack",
	"live_casino": "Canlı Casino",
	"live_roulette": "Canlı Rulet",
	"live_stats": "Canlı İstatistikler",
	"live_support": "Canlı Destek",
	"live_wins": "Canlı Kazançlar",
	"loading": "Yükleniyor",
	"loading_games": "Oyunlar yükleniyor...",
	"loading_more_games": "Daha fazla oyun yükleniyor...",
	"lobby": "Lobi",
	"locked_balance": "Kilitli bakiye",
	"log_in": "Giriş Yap",
	"log_out": "Çıkış Yap",
	"login": "Giriş Yap",
	"login_via_wallet": "Cüzdan ile giriş yap",
	"logout": "Çıkış Yap",
	"lose": "Kaybet",
	"lucky_spin": "Lucky Spin",
	"luna_all_rights_reserved": "LUNABET Hollanda Antilleri Curaçao yasaları çerçevesinde verilen  GCB (OGL/2024/920/0382) Lisansı kapsamında çalışır. Curaçao Hükümeti tarafından yetkilendirilmiş ve düzenlenmiştir. Lunabet® bir Coinbar N.V markasıdır. Heelsumstraat 51 Curacao, CW",
	"luna_bets": "Bahisleri",
	"luna_jackpot": "Jackpot",
	"maintenance_contact_support": "Destekle iletişime geç",
	"maintenance_description_intro": "Şans asla uyumaz, ama bazen sihri ince ayar yapmamız gerekir! {BRAND}, oyun deneyiminizi akıcı, güvenli ve heyecan verici tutmak için şu anda bakımda.",
	"maintenance_description_outro": "Çok yakında geri döneceğiz—daha iyi, daha hızlı ve daha fazla büyük kazanç için hazır!",
	"maintenance_follow_us": "Güncellemeler için bizi takip et",
	"maintenance_sorry_text": "Üzgünüz! {BRAND} şu anda bakımda.",
	"maintenance_support": "Yardıma mı ihtiyacın var?",
	"maintenance_title": "Kısa Bir Mola Veriyoruz",
	"make_a_bet": "Bahis yap",
	"make_it_rain": "Yağdır",
	"make_primary": "Ana e-posta olarak ayarla",
	"mark_all_as_read": "Tümünü okundu işaretle",
	"mark_as_read": "Okundu işaretle",
	"marketing_emails": "Pazarlama E-postalarına Abone Olundu",
	"max": "Maks",
	"max_bonus": "Maks bonus",
	"max_eligible_users": "Maks uygun kullanıcı",
	"max_tip": "Maksimum bahşiş aşıldı",
	"max_win": "Maks Kazanç",
	"maximize_playtime_rewards_description": "En üst düzey keyif için günlük, haftalık ve aylık ödül talepleriyle oyun süreni maksimize et! Katkın, Flush’un house edge’inden daha büyük bir pay kazandırır.",
	"maximum_is": "Maksimum",
	"meme_coins": "Meme Coin’ler",
	"menu": "Menü",
	"message": "Mesaj",
	"message_optional": "Mesaj (isteğe bağlı)",
	"min": "Min",
	"min_deposit": "Min Yatırma",
	"min_deposit_amount": "Minimum yatırma tutarı",
	"min_tip": "Minimum bahşiş karşılanmadı.",
	"mines": "Mines",
	"minimal_claim": "Minimum talep",
	"minimum_deposit": "Minimum yatırma tutarı",
	"minimum_deposit_short": "Minimum yatırma",
	"minimum_deposit_tooltip": "⚠️ Minimum yatırma tutarı 0.00000224 BTC’dir. Daha az gönderilmesi fon kaybıyla sonuçlanır. Maksimum yatırma yoktur. Flush, BTC yatırma işlemlerinde ücret almaz. Yatırmalar ağ koşulları nedeniyle zaman alabilir.",
	"minimum_withdrawal": "Minimum çekim",
	"missed": "Kaçırıldı",
	"missed_it_by_the_day": "Bir günle kaçırdın",
	"mma": "MMA",
	"mnf_bet_builder_bailout": "Monday Night Football Bet Builder Bailout",
	"mnf_bet_builder_bailout_description": "Tek ayakla kaybet, PARANI GERİ AL!",
	"modal_dialog": "Modal Diyalog",
	"moderator": "Moderatör Sitesi",
	"monthLabel": "Ay",
	"monthly": "Aylık Bonus",
	"monthly_bonus": "Aylık bonus",
	"monthly_bonus_text": "Aylık Bonus",
	"monthly_bonuses_text": "Aylık Bonuslar",
	"monthly_limit": "Aylık çekim limitlerinize ulaştınız. Çekim limitlerinin yenilenmesi için lütfen [TIME] gün sonra tekrar deneyin.",
	"monthly_rewards_tooltip": "Aylık aktiviteye dayalı bonus. Bakiyenize ve 14 günlük takviminize aktarılır.",
	"monthly_rewards_tooltip_flush": "Aylık aktiviteye dayalı bonus. Bakiyenize ve 30 günlük takviminize aktarılır.",
	"more_text": "Daha fazla",
	"more_vip_rewards": "Her yerdekinden Daha Fazla VIP Club Ödülü & Cashback",
	"movie_mode": "Sinema Modu",
	"multiplier": "Çarpan",
	"multiplier_madness": "Multiplier Madness",
	"multiplier_madness_description": "Bu haftanın 5 oyununu oynayarak 10.000 $’lık ödül havuzundan payını al.",
	"my_balance": "Bakiyem",
	"my_bets": "Bahislerim",
	"my_campaigns": "Kampanyalarım",
	"my_commission": "Komisyonum",
	"my_profit": "Kârım",
	"my_referral_campaign": "Referral kampanyam",
	"my_referral_rewards": "Toplam referral ödüllerim",
	"my_referrals": "Yönlendirmelerim",
	"my_total_profit": "Toplam kârım",
	"my_total_referrals": "Toplam Yönlendirmelerim",
	"name": "İsim",
	"nba_2k": "Nba 2K",
	"negative_balances_policy": "Negatif bakiyeler devreder mi?",
	"negative_balances_policy_answer": "[BRAND] Partners’ta hayır. Bir partnerin yönlendirmesi şanslı olup negatif bir NGR ve affiliate bakiyesi oluşturursa, bu bir sonraki aya devretmez. Sonraki ayın kazanç hesaplaması net sıfırdan başlar.",
	"network": "Ağ",
	"network_error": "Ağ Hatası",
	"networks": "Ağlar",
	"new": "Yeni",
	"new_bonuses_in": "Yeni Bonuslar Şurada",
	"new_casino_games": "Yeni Oyunlar",
	"new_client_seed": "Yeni Client Seed",
	"new_games": "Yeni Oyunlar",
	"new_release": "New Release",
	"new_releases": "Yeni Çıkanlar",
	"new_server_seed_hashed": "Yeni Server Seed Hashlendi",
	"next": "Sonraki",
	"next_rank": "Sonraki Rank",
	"next_rank_up_reward": "Yaklaşan Rank Up Ödülü",
	"next_ranks": "Sonraki Rank’lar",
	"next_reward_in": "Sonraki ödüle",
	"nfl": "NFL",
	"ngr_details": "Yüksek Net Oyun Geliri (NGR) sağlayan, üst düzey bir kripto marka — bu da affiliate gelirinin artmasını sağlar.",
	"nickname": "Takma ad",
	"no": "Hayır",
	"no_bets_transactions_found_flush_part_1": "Henüz işlem yok",
	"no_bets_transactions_found_flush_part_2": "Oynamaya başladığında,\nbahislerin burada görünecek.",
	"no_bonus": "Bonus istemiyorum",
	"no_deposits_transactions_found_flush_part_1": "Henüz yatırma yok",
	"no_deposits_transactions_found_flush_part_2": "Cüzdanına para eklediğinde,\nyatırma geçmişin burada görünecek.",
	"no_games_found": "Oyun bulunamadı",
	"no_games_found_flush_part_1": "Hoppala!",
	"no_games_found_flush_part_2": "Böyle bir oyunumuz yok",
	"no_info_available": "Bilgi mevcut değil",
	"no_information": "Bilgi yok",
	"no_ratings_yet": "Henüz puan yok. Bu oyunu ilk sen puanla!",
	"no_response_from_server": "Sunucudan yanıt yok.",
	"no_reward_yet": "Henüz ödül yok",
	"no_rewards": "Ödül yok",
	"no_transactions_found_flush_part_1": "Henüz işlem yok",
	"no_transactions_found_flush_part_2": "Oynamaya başladığında bahislerin ve\nödüllerin burada görünecek.",
	"no_user_found": "Bu kullanıcı adıyla kullanıcı bulunamadı",
	"no_withdrawals_transactions_found_flush_part_1": "Henüz çekim yok",
	"no_withdrawals_transactions_found_flush_part_2": "Bir cashout talep ettiğinde,\ndurumuyla birlikte burada göreceksin.",
	"non_calendar_reward_claimed_successfully": "[AMOUNT] Başarıyla Talep Edildi!",
	"non_calendar_reward_claimed_successfully_text": "[AMOUNT] tutarının bir kısmı bakiyene eklendi. Kalanı Rewards Calendar’ına eklendi.",
	"nonce": "Nonce",
	"none": "yok",
	"nor_any_network": "Yukarıda listelenmeyen herhangi bir ağ da dahil değil",
	"nor_any_token": "Yukarıda listelenmeyen herhangi bir token da dahil değil",
	"not_eligible": "Uygun Değil",
	"not_found": "Bulunamadı",
	"notifications": "Bildirimler",
	"now_its_time_to_win": "Şimdi kazanma zamanı!",
	"number_referrals": "Yönlendirme Sayısı",
	"obsidian": "Obsidian",
	"of": " / ",
	"offers": "Teklifler",
	"on": "üzerinde",
	"online": "Çevrimiçi",
	"online_casino": "Online Casino",
	"online_slots": "Online Slotlar - Plinko - Rulet - Blackjack ve Daha Fazlası!",
	"online_slots_providers": "Sağlayıcılar",
	"only_on_turbo": "ONLY ON TURBO",
	"only_the_games_you_want_to_play": "Sadece oynamak istediğin oyunlar",
	"open_in_new_tab": "Yeni sekmede aç",
	"opt_in_now": "Şimdi katıl",
	"optional": "isteğe bağlı",
	"or": "veya",
	"or_more_and_get_a": "veya daha fazlası ve şunu al:",
	"ordinal": "{{n}}{{suffix}}",
	"originals": "Orijinaller",
	"originals_fomoio": "Fomo Originals",
	"other": "Diğer",
	"other_currencies": "Diğer Para Birimleri",
	"out_of_days_done": "[DAYS_COMPLETED] / [DAYS_TOTAL] gün tamamlandı. Gayet iyi.",
	"over_x_payment_methods": "[QUANTITY]+ ödeme yöntemi",
	"page": "Sayfa",
	"page_not_found": "Sayfa bulunamadı",
	"participating_games": "Orijinaller <br /> Casino <br /> Canlı Casino",
	"participating_games_title": "Katılan oyunlar:",
	"partner_review_1": "[BRAND] Partners ile iş birliği yapmak stratejik bir ustalık hamlesiydi. Ekipleri yalnızca kampanyaları yürütmedi; iş hedeflerimize entegre olup, çeyreklik tahminlerimizi yeniden şekillendiren bir büyüme sağladı.",
	"partner_review_10": "[BRAND] Partners ile yaptığımız çalışmanın yatırım geri dönüşü net ve ikna ediciydi. Somut değer gösterdiler; iş birliğini son derece akıllı bir iş kararı haline getirdiler.",
	"partner_review_11": "Zorluklar ortaya çıktığında [BRAND] ekibi olağanüstü problem çözücüler olduğunu gösterdi. Analitik ve sakin yaklaşımları engelleri optimizasyon fırsatlarına dönüştürdü.",
	"partner_review_12": "[BRAND]’taki her bireyin profesyonelliği takdire şayan. Etkileşimler her zaman verimli, saygılı ve ortak hedeflere odaklı.",
	"partner_review_13": "[BRAND] sadece hedefleri karşılamıyor; onları yeniden tanımlıyor. Hırsları ve azimleri, kampanyalarımızı daha önce ulaşılamaz sandığımız performans seviyelerine taşıdı.",
	"partner_review_14": "[BRAND] Partners’ın sağladığı uzun vadeli stratejik vizyon paha biçilemezdi. Kısa vadeli kampanya sıçramaları değil, sürdürülebilir bir büyüme motoru kurmamıza yardımcı oldular.",
	"partner_review_18": "[BRAND] Partners ile çalışmak, bir pazarlama partnerinden beklentilerimizi yukarı taşıdı. Performansları, organizasyonumuz içinde mükemmellik için yeni bir standart belirledi.",
	"partner_review_19": "[BRAND] netlik sunar. Raporlamaları, çabaları ile en kritik iş sonuçlarımız arasında kristal netliğinde bir görünürlük sağlar; şüpheye yer bırakmaz.",
	"partner_review_2": "[BRAND] Partners ekibindeki sektör bilgisi derinliği inanılmaz. Karmaşık pazar dinamiklerini kolaylıkla yöneterek bize net ve güven veren bir yol haritası sundular.",
	"partner_review_20": "[BRAND] ile tüm iş akışı sorunsuz ve verimliydi. İyi tanımlanmış süreçleri ve uzman proje yönetimi, iş birliğini zahmetsiz ve oldukça üretken hale getirdi.",
	"partner_review_21": "[BRAND] ile ortaklığımız temel taşı niteliğinde oldu. Sadece anlık sonuçlar sunmadılar; gelecekteki büyüme için sağlam bir çerçeve kurmamıza da yardımcı oldular.",
	"partner_review_22": "GambleGrounds.com olarak [BRAND].com ile ortaklığımız olağanüstü. [BRAND] Casino gibi yüksek dönüşüm sağlayan bir marka ile kazan-kazan ilişkisi sunuyorlar ve oyuncu deneyimi mükemmel. Esnek komisyon hibrit modellerini ve negatif bakiyenin devretmemesi gibi büyük avantajı özellikle önemsiyoruz. Özel affiliate yöneticimiz Robert’ın desteği ise birinci sınıf—her zaman hızlı yanıt veren ve proaktif. Güçlü analitikleri ve zamanında ödemeleriyle birleşince ideal bir partner oluyorlar. Profesyonel, şeffaf ve ödüllendirici bir iş birliği arayan her iGaming affiliate’ine [BRAND] Affiliate’i gönül rahatlığıyla öneriyoruz. Gerçekten bir adım öndeler.",
	"partner_review_23": "[BRAND].com sadece beklentileri karşılamıyor; onları sürekli yeniden tanımlıyor. Teknoloji, pazarlama ve destek alanlarındaki mükemmelliğe olan sarsılmaz bağlılıkları, çeyrekten çeyreğe öngörülebilir ve olağanüstü sonuçlar getiriyor.",
	"partner_review_24": "[BRAND], online kumar sektöründe sahip olunabilecek harika bir partner. Yöneticileri son derece destekleyici ve kolayca ulaşılabilir. paynplay-kasinot.com ekibi, [BRAND] affiliates ile iş birliğini şiddetle tavsiye eder.",
	"partner_review_25": "[BRAND] Partners ekibiyle çalışmak harika; oyuncuların ne istediğini gerçekten iyi anlıyorlar. Markaları; adil şartlar, ödüllendirici bonuslar ve hızlı ödemelerle gerçek değer sunuyor — oyuncuların gerçekten takdir ettiği bir kombinasyon.",
	"partner_review_26": "Merhaba, ben Tony Lee; 1XGAMBLE işletmecisi ve online casino endüstri analistiyim. [BRAND] Casino, kayıt süreçlerinden oyun deneyimine ve çekimlere kadar kusursuz bir akış sunan, yalnızca kripto odaklı bir online casino markası olarak öne çıkıyor.",
	"partner_review_27": "[BRAND].Partners are dependable on the partnership side, reports are accurate, deep links stay intact, and the team provides focused landing pages. Updates come with clear notes, which keep reviews tidy and current.",
	"partner_review_28": "[BRAND] Partners ile bir süredir çalışıyoruz ve iletişimleri, raporlamaları ve ödemeleri tam bir profesyonellikle yürütülüyor. Ekip, işbirliğinin her açısında güvenilir, şeffaf ve verimlidir.",
	"partner_review_29": "[BRAND], kripto bahisçileriyle çalışan herkes için vazgeçilmezdir. Kullanıcılarımız, spor bahisleri ve casino oyunlarının kaliteli kombinasyonu ile cazip promosyonlar sayesinde siteden keyif aldı. [BRAND] ortak programını diğerlerine şiddetle tavsiye ediyoruz.",
	"partner_review_3": "Abartılı vaatlerin olduğu bir dünyada [BRAND], sarsılmaz güvenilirliğiyle öne çıkıyor. İddialı hedefler koyuyorlar ve ardından bunları sistematik, şeffaf ve tutarlı şekilde gerçekleştiriyorlar.",
	"partner_review_30": "[BRAND] ile çalışmak mükemmel bir seçim olduğunu kanıtladı. Büyüleyici oyunları ve cömert bonusları, yeni oyuncular çekmeyi zahmetsiz kılıyor ve müşteri desteği olağanüstü.",
	"partner_review_4": "[BRAND], aklımıza gelmeyen yenilikçi taktikler sundu. Yaratıcı ve veriye dayalı yaklaşımları pazardaki gürültüyü aşıp olağanüstü etkileşim getirdi.",
	"partner_review_5": "Bu, müşteri-tedarikçi ilişkisinden çok stratejik bir ittifak gibiydi. [BRAND] Partners başarımıza gerçekten yatırım yaptı; kendi ekibimizin gerçek bir uzantısı gibi hareket etti.",
	"partner_review_6": "[BRAND]’un temel iş metriklerimize odaklanması ferahlatıcıydı. Her strateji, kârlılığımız açısından gerçekten önemli olan noktada etki yaratmaya bağlıydı.",
	"partner_review_7": "[BRAND] Partners ekibinin şeffaflığı büyük bir güven oluşturdu. Net raporlama ve proaktif iletişimle hiçbir zaman belirsizlik yaşamadık.",
	"partner_review_8": "Pazar dinamik ve [BRAND] da öyle. Stratejileri gerçek zamanlı hızla uyarlayıp optimize etme yetenekleri, olası zorlukları en büyük kazanımlarımıza dönüştürdü.",
	"partner_review_9": "[BRAND]’un uygulaması kusursuz. Detaylara verdikleri önem ve kaliteye bağlılıkları; her varlıkta, her lansmanda ve her kampanya raporunda kendini gösteriyor.",
	"partner_testimonials": "Partnerlerimiz Ne Diyor",
	"partners_perks": "[BRAND] Partners, #1 kripto casino affiliate programı olmayı hedefler. Bunu sağlamak için [BRAND] affiliate’leri şu ayrıcalıklardan yararlanır:",
	"partners_program": "[BRAND] Partners Programı",
	"partners_program_overview": "[BRAND] Partners Programı nedir?",
	"partners_program_overview_answer": "[BRAND] Partners, [BRAND] Casino’nun kazançlı Affiliate Programıdır. İşletmeler ve bireyler, oyuncuları [BRAND] Casino’ya yönlendirerek trafiğini gelire dönüştürebilir.",
	"partnership_enquiries": "Ortaklık Soruları",
	"password": "Şifre",
	"passwordMethod": "Şifre Yöntemi",
	"payment_details": "Her ayın ilk günlerinde hızlı ve verimli ödemeler.",
	"payment_policy": "Ödeme Politikası",
	"payout": "Ödeme",
	"pending": "Beklemede",
	"pending_commission": "Bekleyen komisyon",
	"pending_reward": "Bekleyen ödül",
	"pending_rewards": "Bekleyen Ödüller",
	"period": "Dönem",
	"personal": "KİŞİSEL",
	"personal_tab": "Kişisel",
	"platform": "Platform",
	"platinum": "Platinum",
	"play": "Oyna",
	"play_crypto_testimonial": "[BRAND] Partners ile çalışmak bir keyif; affiliate ekipleri her zaman yanıt vermeye ve sorulara yardımcı olmaya istekli. En önemlisi, [BRAND] kripto trafiğimiz için ideal, harika bir kripto casino.",
	"play_now": "Şimdi Oyna!",
	"play_online": "Flush’ta Online Slotlar, Blackjack, Rulet, Poker oyna veya Sports Book’ta bahis yap — Kripto Casino.",
	"play_requirement": "Oyun Gereksinimleri",
	"play_requirement_description": "Çekim işleme alınmadan önce yatırma işleminizi en az 1x oynamanız gerekir.",
	"player": "Oyuncu Sitesi",
	"player_since": "Oyuncu Olma Tarihi",
	"players_online": "[COUNT] Oyuncu Çevrimiçi",
	"players_settings": "Oyuncu Ayarları",
	"please_check_wallet_and_accept_the_request_to_continue": "Lütfen cüzdanınızı kontrol edin ve isteği kabul ederek devam edin.",
	"please_enter_deposit_amount": "Lütfen yatırma tutarını girin",
	"please_only_use_one_of_these_networks": "Lütfen yalnızca bu ağlardan birini kullanın",
	"plinko": "Plinko",
	"popular": "Popüler",
	"popular_casino": "Popüler Oyunlar",
	"popular_games": "Popüler Oyunlar",
	"popularity": "Popülerlik",
	"postalCodeLabel": "Posta Kodu",
	"postalCodePlaceholder": "Posta kodunuzu girin",
	"potencial_questions": "Muhtemel sorularını yanıtladık!",
	"powered_by": "Destekleyen",
	"preferences": "Tercihler",
	"preferredNameLabel": "Tercih Edilen İsim",
	"previous_rounds_history": "Önceki Tur Geçmişi",
	"price_tooltip": "ℹ️ Kur, seçilen ödeme yöntemine bağlıdır. Kripto para cinsinden gerçek satın alma tutarları değişebilir.",
	"privacy": "Gizlilik",
	"privacy_policy": "Gizlilik Politikası",
	"privacy_settings": "Gizlilik",
	"prize_pool_table_header_position": "Sıra",
	"prize_pool_table_header_prize": "Ödül",
	"prize_pool_table_header_username": "Kullanıcı Adı",
	"prize_pool_table_header_wagered": "Bahis",
	"prize_pool_title_part_1": "Ödül Havuzu:",
	"prize_pool_title_part_2": "$10,000",
	"processing": "İşleniyor",
	"profile": "Profil",
	"profit": "Kâr",
	"program_working_details": "[BRAND] Partners Programı nasıl çalışır?",
	"program_working_details_answer": "Yeni affiliate’ler Affiliate Platformumuzda kayıt olmalıdır. Atanan affiliate yöneticileri hesap kurulumunda yardımcı olur. Aktif olduktan sonra, yönlendirdikleri kişilerin kayıt olup oynaması için paylaşabilecekleri bir referral URL veya Referral Code verilir ve affiliate komisyonu kazanılır.",
	"progress": "İlerleme",
	"promo": "Promo",
	"promo_materials": "Promo materyalleri",
	"promoted_game": "PROMOTED GAME",
	"promotion_period_from_label": "Başlangıç:",
	"promotion_period_to_label": "Bitiş:",
	"promotion_restrictions": "[BRAND] referral linkimi tanıtırken herhangi bir kısıtlama var mı?",
	"promotion_restrictions_answer": "Hiçbir koşulda [BRAND] Casino ve marka iştirakleri; reşit olmayanlara veya kumar bağımlılığı sorunu olan bireylere tanıtılmamalıdır. Ayrıca engellenen coğrafyalara tanıtım ve brand bidding yasaktır. Daha fazla bilgi için lütfen affiliate şartlar ve koşullarımıza bakın.",
	"promotional_materials_provided": "[BRAND], affiliate’lerine hangi tür promosyon materyalleri sağlar?",
	"promotional_materials_provided_answer": "[BRAND] Partners, affiliate’lerin ihtiyaç duyacağı her şeyi sağlar. Buna banner’lar, logolar, bonus kodları, özel URL’ler ve benzersiz içerikler dahildir.",
	"promotions": "Promosyonlar",
	"promotions_details": "Cashback’ten free spinlere ve çekilişlere kadar uzanan düzenli promosyonlar; dönüşüm oranlarını artırır ve oyuncuları memnun eder.",
	"provably_fair": "Provably Fair",
	"provably_fair_casino_games": "Kanıtlanabilir Adil Casino Oyunları",
	"provider_search": "Sağlayıcıya Göre Oyun Ara",
	"providers": "Sağlayıcılar",
	"provinceLabel": "Eyalet",
	"provincePlaceholder": "Eyaletinizi girin",
	"public": "Herkese Açık",
	"qualifying_range": "Uygunluk Aralığı",
	"quest": "Görev",
	"question_daily_weekly_monthly": "Günlük, haftalık, aylık bonusum nedir?",
	"question_how_communicate": "VIP Host’um ile nasıl iletişim kuracağım?",
	"question_how_ofter_bonuses": "Flush VIP Club ile bonusları ne sıklıkla alacağım?",
	"question_monthly_bonus": "Aylık bonus ne zamana planlanır?",
	"question_vip_club_stand_out": "Flush’un VIP Club’ını diğerlerinden farklı kılan nedir?",
	"question_wagering": "Wagering’im nasıl hesaplanır?",
	"question_what_are_calendar_distribuition_days": "Calendar Distribution Days nedir?",
	"question_what_is_cashback": "Cashback nedir?",
	"question_what_is_happy_hour": "Happy Hour nedir?",
	"question_what_is_rakeback": "Rakeback nedir?",
	"question_which_tier_im_on": "Hangi seviyede olduğumu ve bir sonraki seviyeye ne kadar kaldığını nasıl görebilirim?",
	"quote": "Alıntı",
	"race_leaderboard": "Race Liderlik Tablosu",
	"race_now": "Şimdi Yarış!",
	"race_your_way": "Her hafta 10.000 $ ödül için yarış ve kazanmaya ilerle!",
	"races": "Races",
	"races_banner_description": "Her hafta 10.000 $ ödül için yarış ve kazanmaya ilerle!",
	"races_description": "Haftalık 10.000 $ Nakit için Yarış",
	"races_fomoio": "Fomo.io Races",
	"racing": "Motosiklet Yarışı",
	"raffles": "Çekilişler",
	"rain": "Rain",
	"rain_amount": "Rain Tutarı",
	"rain_currency": "Rain Para Birimi",
	"rain_error_status": "Rain gönderilirken bir hata oluştu.",
	"rain_exceeds_balance": "Rain tutarı mevcut bakiyenizi aşıyor.",
	"rain_failed": "Rain Başarısız",
	"rain_invalid": "Geçersiz Rain",
	"rain_maximum_description": "Tutar, kullanıcı başına izin verilen maksimumun üzerinde.",
	"rain_minimum_description": "Tutar, kullanıcı başına izin verilen minimumun altında.",
	"rain_sent": "Rain Gönderildi",
	"rain_sent_success": "Rain başarıyla gönderildi.",
	"rain_too_large": "Rain Çok Büyük",
	"rain_too_small": "Rain Çok Küçük",
	"rain_total_overall_max_description": "Toplam tutar, izin verilen genel maksimumu aşıyor.",
	"rain_total_too_large_description": "Toplam tutar, kullanıcı sayısına göre çok yüksek.",
	"rain_total_too_small_description": "Toplam tutar, kullanıcı sayısına göre çok düşük.",
	"raise_your_game_and_stay": "Oyununuzu yükseltin ve devam edin",
	"rakeback": "Rakeback",
	"rakeback_claimed": "Rakeback Talep Edildi",
	"rakeback_perks_description": "Rakeback Ayrıcalıkları",
	"rakeback_text": "Rakeback",
	"rakeback_tooltip": "House edge’in belirli bir yüzdesini geri kazan. 5$+ biriktiğinde talep edilebilir. Yeni VIP rank’lara ulaştıkça rakeback oranı artar!",
	"rakeboost": "Rakeboost",
	"rakeboost_description": "Her ödül talebinde %15 ekstra Rakeback kap",
	"rakeboost_happy_hour_description": "Rakeboost Happy Hour",
	"rakeboost_text": "Rakeboost",
	"rakeboost_tooltip": "Bir ödül talep ettikten sonra günde bir kez boosted rakeback al. Boost oranı VIP rank’ına bağlıdır.",
	"rank": "Rank",
	"rank_bronze": "Bronze",
	"rank_details": "Rank Detayları",
	"rank_diamond": "Diamond",
	"rank_emerald": "Emerald",
	"rank_gold": "Gold",
	"rank_iron": "Iron",
	"rank_obsidian": "Obsidian",
	"rank_platinum": "Platinum",
	"rank_silver": "Silver",
	"rank_titanium": "Titanium",
	"rank_up": "Level Up Ödülü",
	"rank_up_reward": "Rank Up",
	"rank_up_tooltip": "VIP seviye atlama aktivitesine dayalı bonus. Bir yüzdesi bakiyene aktarılır, kalan kısmı 21 günlük takvimine. ",
	"rank_vibranium": "Vibranium",
	"rank_vip": "VIP",
	"rankname": "Rank adı",
	"ranks": "Rank’lar",
	"reach_out_at": "Bize ulaşın:",
	"read_more": "Daha fazlasını oku",
	"ready_to_hit_jackpot": "Jackpot’u vurmaya hazır mısın?",
	"ready_to_text": "Hazır mısın",
	"real_money": "Gerçek para",
	"real_play": "Gerçek Oyun",
	"real_time_affiliate_data": "Gerçek Zamanlı Affiliate Verisi",
	"receives_your_referral": "Yönlendirmelerini alır",
	"recently_added": "Yeni eklendi",
	"recently_played": "Son oynananlar",
	"reel_design": "Reel Tasarımı",
	"refer_and_earn": "Refer & Earn",
	"refer_and_earn_banner_description": "Yönlendirmelerinin oyununa göre her ay nakit ödül kazan.",
	"refer_and_earn_banner_description_mobile": "Yönlendirmelerinin oyununa göre her ay nakit ödül kazan.",
	"refer_and_earn_banner_title": "Refer & Earn",
	"refer_new_users_to_get": "ARKADAŞLARINI DAVET ET VE KAZAN",
	"refer_now": "Şimdi yönlendir!",
	"referal_code": "Referal kodu",
	"referral": "Referral",
	"referral_banner_description_part_1": "<span class='yellow-text'>Flush.com</span>'da arkadaşlarını ve onların arkadaşlarını oynatarak her ay gerçek nakit kazan. Bahis yapsalar bile ödüllendirilirsin!",
	"referral_banner_description_part_2": ". Bahis yapsalar bile ödüllendirilirsin!",
	"referral_banner_title_part_1": "Arkadaşlarını Davet Et",
	"referral_banner_title_part_2": "ve kazan",
	"referral_code": "Referral kodu",
	"referral_commission": "Referral komisyonu",
	"referral_commission_rewards": "Referral Komisyon Ödülleri:",
	"referral_dashboard": "Referral paneli",
	"referral_limit_details": "[BRAND]’a kaç referral getirebileceğime dair bir limit var mı?",
	"referral_limit_details_answer": "Hayır. Bir affiliate ne kadar çok oyuncu yönlendirirse o kadar iyi! Bu, affiliate’in düzenli gelir elde edebileceği sağlam bir oyuncu tabanı oluşturur.",
	"referral_link": "Referral linki",
	"referral_link_code": "Referral link/kodu",
	"referral_program": "Referans Programı",
	"referral_progress_tooltip": "Referral Ödülleri Kazan\n\nEn aktif ilk 5 arkadaşın (ve onların en aktif arkadaşları) bahis yaptığında komisyon kazanırsın. Kazansalar bile!\n\nKomisyon:\n- Birincil referral’lar (Tier 1): %20\n- İkincil referral’lar (Tier 2): %10\n- Üçüncül referral’lar (Tier 3): %5\n\nHesaplama:\n(Bahis Tutarı x Teorik House Edge ÷ 2) x Yüzde Olarak Komisyon Oranı.\n\nZamanlama:\nReferral komisyonları, bir önceki ayki referral aktivitesi için ayda bir kez hesabına aktarılır.",
	"referral_progress_tooltip_2": "En aktif ilk 5 doğrudan referral’ınız ve onların en aktif referral’ları referral ödülleri oluşturur.\n\nYani şu kişilerden ödül kazanabilirsin:\nEn aktif ilk 5 doğrudan referral’ınız\n+ 25 ikincil referral (en aktif 5 doğrudan referral’ınız x onların en aktif 5 doğrudan referral’ı)\n+ 125 üçüncül referral (en aktif 25 ikincil referral’ınız x onların en aktif 5 doğrudan referral’ı)",
	"referral_reward": "Oluşturulan Ödüller",
	"referral_rewards_rules": "Referral Ödül Kuralları",
	"referral_rewards_rules_step_1": "Bir arkadaşını davet et ve $2000 kazan.",
	"referral_rewards_rules_step_2": "Ödüllerin başlangıçta kilitli olacak. $2000 kazan.",
	"referral_rewards_rules_step_3": "Arkadaşların seviye atladıkça ödüllerini alırsın.",
	"referral_rules_added_to_your_balance": "“En aktif” tanımı, takvim ayı boyunca toplam nakit turnover’a göre belirlenir.",
	"referral_rules_period": "Bu, her ay en fazla 155 ödüllendirilen referral demek!",
	"referral_rules_primary_description": "Aylık en aktif 5 doğrudan referral’ınız üzerinden %20 komisyon kazanırsınız.",
	"referral_rules_primary_referrals": "Birincil referral’lar",
	"referral_rules_secondary_description": "Tier 1 oyuncularının her birinin en aktif 5 referral’ından %10 kazanırsın (en fazla 25).",
	"referral_rules_secondary_referrals": "İkincil referral’lar",
	"referral_rules_tertiary_description": "Her Tier 2 oyuncunun en aktif 5 referral’ından %5 kazanırsın (en fazla 125).",
	"referral_rules_tertiary_referrals": "Üçüncül referral’lar",
	"referral_rules_you_earn": "Arkadaşların (veya onların arkadaşları) bahis yaptığında komisyon kazanırsın. Kazansalar bile!",
	"referral_stats_tooltip": "Şu ana kadarki tüm aktiviten boyunca kazandığın toplam Referral Ödülleri.",
	"referral_subtitle": "3 kademeli referral & %35 ömür boyu komisyon",
	"referral_system": "Referral sistemi",
	"referral_tier": "Referral Seviyesi",
	"referral_tracking_details": "Referral’larımı ve komisyonlarımı takip edebilir miyim?",
	"referral_tracking_details_answer": "Evet, [BRAND] Partners; affiliate’lerin istatistiklerini takip etmesine olanak tanıyan Affilka Affiliate Marketing and Management Software ile iş birliği yaptı.",
	"referral_username": "Kullanıcı adı",
	"referrals": "Referral’lar",
	"referrers_bonus": "Referrer Bonusu",
	"refresh_page": "Sayfayı Yenile",
	"register": "Kayıt Ol",
	"registered": "Kayıtlı",
	"regular_promotions": "Düzenli Promosyonlar",
	"rejected": "Reddedildi",
	"remember_only_usdt": "Unutma, yalnızca USDT çekebileceksin.",
	"reporting_details": "Optimizasyon ve takip için istatistiklerin gerçek zamanlı raporlanması.",
	"requested": "Talep Edildi",
	"requirekeyOrCode": "Şifrene ek olarak bir güvenlik anahtarı veya kodu gerekli kıl",
	"resend": "Yeniden gönder",
	"resend_code": "Kodu yeniden gönder",
	"reset": "Seçileni temizle",
	"response_time": "Yanıt süresi:",
	"responsible_gaming": "Sorumlu Oyun",
	"returned": "İade edildi",
	"returning": "Dönüyor",
	"reversed": "Geri alındı",
	"reviews_average_rating": "Ortalama Puan",
	"reviews_based_on_user_ratings": "{count} kullanıcı puanına göre",
	"reviews_be_first_to_comment": "İlk yorumu sen yap!",
	"reviews_comments": "Yorumlar",
	"reviews_i_love_it": "Bayıldım",
	"reviews_leave_your_comment": "Yorumunu bırak",
	"reviews_login_to_post": "YORUM YAPMAK İÇİN GİRİŞ YAP",
	"reviews_most_popular": "En Popüler",
	"reviews_most_recent": "En Yeni",
	"reviews_no_comments_yet": "Henüz yorum yok. İlk yorumu sen yap!",
	"reviews_oldest": "En Eski",
	"reviews_post": "GÖNDER",
	"reviews_rate_this_game": "Bu oyunu puanla",
	"reviews_rating_amazing": "Muhteşem",
	"reviews_rating_fair": "Orta",
	"reviews_rating_good": "İyi",
	"reviews_rating_poor": "Kötü",
	"reviews_rating_very_good": "Çok İyi",
	"reviews_replies": "Yanıt",
	"reviews_reply": "Yanıtla",
	"reviews_tab": "İnceleme",
	"reviews_view_more_comments": "Daha Fazla Yorumu Gör",
	"reward": "Ödül",
	"reward_claimed_successfully": "Ödül Başarıyla Talep Edildi",
	"reward_claimed_successfully_text": "[AMOUNT] Calendar Ödülünüz başarıyla talep edildi!",
	"reward_details": "Ödül Detayları",
	"reward_history": "Ödül Geçmişi",
	"reward_promo_daily_bonus_description": "Her gün oyna, her gün kazan.\nBonus her 24 saatte bir düşer.",
	"reward_promo_daily_bonus_title": "GÜNLÜK BONUS",
	"reward_promo_level_up_bonus_description": "Her yeni seviye ödeme yapar.\nYükselmeye devam et.",
	"reward_promo_level_up_bonus_title": "SEVİYE ATLAMA BONUS",
	"reward_promo_monthly_bonus_description": "Ayın en büyük bonusu.\nOyununa göre belirlenir.",
	"reward_promo_monthly_bonus_title": "AYLIK BONUS",
	"reward_promo_rakeback_description": "Her bahiste rakeback kazan.\nHer 30 dakikada bir talep et.",
	"reward_promo_rakeback_title": "RAKEBACK",
	"reward_promo_weekly_bonus_description": "Bu hafta ne kadar çok oynarsan,\nbonusun o kadar büyür.",
	"reward_promo_weekly_bonus_title": "HAFTALIK BONUS",
	"reward_to_claim": "Talep edilecek ödül",
	"rewarded": "Ödüllendirildi",
	"rewards": "Ödüller",
	"rewards_and_cashback_description": "Her yerdekinden daha fazla Ödül ve Cashback",
	"rewards_program": "Ödül\nProgramı",
	"rewards_progress": "Ödül İlerlemesi",
	"rewards_text": "Ödüller",
	"rocket_affiliate_managers_details": "Yolculuğun her adımında size rehberlik eden deneyimli affiliate yöneticilerinden oluşan bir ekip.",
	"rocket_affiliate_marketing_promotion": "Ciddi trafik getirebileceğinizi mi düşünüyorsunuz? O zaman, ve yalnızca o zaman, [BRAND] Partners sizin için uygun olabilir. Bu, yeni başlayanlar veya yarım yamalayan promoterlar için değil. Ancak gerçek oyuncular getirecek kitleye ve becerilere sahipseniz, [BRAND] Net Game Revenue (NGR) gelirinin %50’sine kadar kazanabilirsiniz. Trafik yoksa sonuç da yok — bu kadar basit.",
	"rocket_boost_up": "Boost Up",
	"rocket_commission_schemes_details": "Yönlendirmelerinizin değerini en üst düzeye çıkaran kazançlı komisyon modelleri.",
	"rocket_contact_us": "Başvurunuzu gönderin",
	"rocket_crypto_casino": "[BRAND] Casino ve Spor Bahisleri",
	"rocket_crypto_casino_description": "[BRAND], ciddi kazanç potansiyeli için tasarlandı; oyuncu yaşam boyu değerini en üst düzeye çıkaran üst düzey bir elde tutma stratejisiyle desteklenir. Özel mobil deneyim ve güçlü dönüşüm odağıyla, yüksek kaliteli trafiği paraya çeviren bir markadır.",
	"rocket_dedicated_affiliate_managers": "Özel affiliate yöneticileri",
	"rocket_different_commission_schemes": "Farklı komisyon modelleri",
	"rocket_earnings_potential_with_partners": "Ciddi trafik mi? Ciddi para kazanın",
	"rocket_fast_efficient_payments": "Hızlı ve verimli ödemeler",
	"rocket_games_details": "Yalnızca en iyi casino oyunları ve oyuncuları mutlu eden geniş bir spor bahisleri seçkisi.",
	"rocket_high_ngr_increased_revenue": "Yüksek NGR, daha fazla gelir",
	"rocket_inner_circle_telegram_description": "Get in. Or watch\nothers claim it first",
	"rocket_inner_circle_telegram_title": "Inner Circle\nTelegram’da",
	"rocket_jackpot_million_description": "Opt-in for a Chance\nto Hit the Big One",
	"rocket_jackpot_million_title": "$1,000,000\nJackpot",
	"rocket_lifetime_commissions": "Ömür boyu komisyonlar",
	"rocket_lifetime_commissions_details": "Yönlendirmelerinizden ömür boyu komisyon — düzenli bir gelir kaynağı.",
	"rocket_ngr_details": "Yüksek Net Gaming Revenue (NGR) elde eden üst düzey bir marka ve buna bağlı olarak daha yüksek affiliate geliri.",
	"rocket_partners_perks": "Herkesi kabul etmiyoruz. Talebinizi ve teklifinizi gönderin — uygun görülürseniz şu avantajları alırsınız:",
	"rocket_partners_program": "[BRAND] ORTAKLIK PROGRAMI",
	"rocket_payment_details": "Nakit veya kripto — her ayın ilk günlerinde hızlı ve verimli ödemeler.",
	"rocket_promotions_details": "Cashback’ten free spin’lere ve turnuvalara kadar düzenli promosyonlar; dönüşümü artırır ve oyuncuları memnun eder.",
	"rocket_races": "Rocket Races",
	"rocket_rakeboost_promo_description": "Turn every reward\nclaim into a 15%\nbigger payday",
	"rocket_rakeboost_promo_title": "Rakeboost",
	"rocket_real_time_affiliate_data": "Gerçek zamanlı affiliate verileri",
	"rocket_regular_promotions": "Düzenli promosyonlar",
	"rocket_reporting_details": "Optimizasyon ve takip için gerçek zamanlı istatistik raporları.",
	"rocket_support_details": "İngilizce, Almanca, Japonca, Arapça ve Fransızca dahil birden fazla dilde affiliate desteği.",
	"rocket_support_in_multiple_languages": "Çok dilli destek",
	"rocket_thousands_of_casino_games": "En iyi oyunlar ve en iyi oranlar",
	"rocket_weekly_prizes_description": "Complete the wheel\nor climb the daily\nleaderboard",
	"rocket_weekly_prizes_title": "100.000\nHaftalık\nÖdüller",
	"rocket_why_choose_partners": "[BRAND] Partners onayını nasıl alırım?",
	"rocketbet_commission_percentage": "Komisyon %",
	"rocketbet_faq_about_refer_and_earn_1": "Komisyon nasıl hesaplanır?",
	"rocketbet_faq_about_refer_and_earn_1_answer": "(Bahis Tutarı x Teorik House Edge ÷ 2) x Komisyon Oranı (% olarak). Örneğin: birincil yönlendirme için %20 komisyon: Dice’ta 100$ bahis, %3 House Edge = 0,30$ kazanç",
	"rocketbet_faq_about_refer_and_earn_2": "Çok kademeli Refer & Earn programında limit var mı?",
	"rocketbet_faq_about_refer_and_earn_2_answer": "Davet edebileceğiniz arkadaş sayısında bir limit yoktur. <br /><br />Uygun yönlendirmelerinizden kazanabileceğiniz referral ödüllerinde de bir limit yoktur. <br /><br />Ancak yalnızca en aktif 5 doğrudan yönlendirmeleriniz ve onların en aktif yönlendirmeleri referral ödülü üretebilir.<br /><br />Yani şu kişilerden ödül alabilirsiniz:<br />En aktif 5 doğrudan yönlendirmeleriniz<br />+ 25 ikincil yönlendirme (en aktif 5 doğrudan yönlendirme × onların en aktif 5 doğrudan yönlendirmesi)<br />+ 125 üçüncül yönlendirme (en aktif 25 ikincil yönlendirme × onların en aktif 5 doğrudan yönlendirmesi)<br /><br />En aktif birincil yönlendirmeleriniz, size üretebilecekleri referral ödülü miktarına göre sıralanır. Hem kendi bahisleri hem de en aktif yönlendirmelerinin bahisleri dikkate alınır.<br /><br />En aktif yönlendirmeleriniz aydan aya değişebilir; bazı eski yönlendirmeler yavaşlarken bazı yeni yönlendirmeler aktivitelerini artırabilir. Amacımız, her zaman en iyi referral ödüllerini almanızı sağlamaktır.",
	"rocketbet_faq_about_refer_and_earn_3": "Diğer promosyonlara yine de hak kazanır mıyım?",
	"rocketbet_faq_about_refer_and_earn_3_answer": "Kesinlikle! Tüm avantajlar, [BRAND]’ya kayıtlı tüm oyuncular için geçerlidir.",
	"rocketbet_faq_about_refer_and_earn_4": "Referral programı nasıl çalışır?",
	"rocketbet_faq_about_refer_and_earn_4_answer": "Arkadaşına referral linkini veya kodunu gönder. O link veya kodla hesap açarlar, yatırma yapar ve oynarlar. Onların oyunlarından (house edge’e göre) ve onların davet ettiği arkadaşların oyunlarından da ödül kazanırsın.",
	"rocketbet_faq_about_refer_and_earn_5": "Arkadaşım da ödül alacak mı?",
	"rocketbet_faq_about_refer_and_earn_5_answer": "Referral programından yalnızca yönlendiren kişi faydalanır. Ancak arkadaşın kendi arkadaşlarını yönlendirip kendi komisyonunu kazanabilir. Bu da senin komisyonunu artırır.",
	"rocketbet_faq_about_refer_and_earn_6": "Referral olarak arkadaşlarımı ben de yönlendirebilir miyim?",
	"rocketbet_faq_about_refer_and_earn_6_answer": "[BRAND]’ya yönlendirilmiş olsanız bile, siz de arkadaşlarınızı yönlendirebilirsiniz. [BRAND]’nun belirlediği sınırlar içinde kalmak için hizmet şartlarına göz atmayı unutmayın.",
	"rocketbet_faq_about_refer_and_earn_7": "Bonus bakiye ile yapılan bahisler referral bahislerine dahil olur mu?",
	"rocketbet_faq_about_refer_and_earn_7_answer": "Hayır. Yalnızca nakit bahisler referral bahislerine dahil edilir.",
	"rocketbet_invite_new_users_and_get_commission": "Davet ettiğiniz her arkadaş için ödül kazanın",
	"rocketbet_invite_your_friends_banner_description": "Arkadaşlarını davet et ve <span class='yellow-text'>[BRAND_DOMAIN]</span> heyecanını keşfetmelerine yardımcı olduğun için ödüllendir",
	"rocketbet_my_referral_rewards": "Toplam referral ödüllerim",
	"rocketbet_my_total_referrals": "Toplam referrallarım",
	"rocketbet_number_referrals": "Referral sayısı",
	"rocketbet_promotions_footer_text_1500_every_week": "$1,500 EVERY WEEK",
	"rocketbet_promotions_footer_text_3000_welcome_bonus": "$3,000 WELCOME BONUS",
	"rocketbet_promotions_footer_text_500_cash_prize": "$500 CASH PRIZE",
	"rocketbet_promotions_footer_text_all_caps": "$1,000,000 ROCKET JACKPOT",
	"rocketbet_promotions_footer_text_boost_your_rewards": "BOOST YOUR REWARDS",
	"rocketbet_promotions_footer_text_daily_rewards": "DAILY REWARDS",
	"rocketbet_promotions_footer_text_exclusive_bonuses": "EXCLUSIVE BONUSES",
	"rocketbet_promotions_footer_text_vip_galaxy": "VIP GALAXY",
	"rocketbet_read_more": "Daha fazla bilgi",
	"rocketbet_refer_and_earn": "DAVET ET & KAZAN",
	"rocketbet_refer_and_earn_banner_tagline": "Birlikte havalanın!",
	"rocketbet_referral_reward": "Referral ödülü",
	"rocketbet_referral_tier": "Referral seviyesi",
	"rocketbet_register": "Kayıt Ol",
	"rocketbet_share_via_socials": "Sosyal medyada paylaş",
	"rocketbet_tier1_referrals": "Seviye 1 (Birincil referrallar)",
	"rocketbet_tier2_referrals": "Seviye 2 (İkincil referrallar)",
	"rocketbet_tier3_referrals": "Seviye 3 (Üçüncül referrallar)",
	"rocketbet_your_referral_link": "Referral linkiniz",
	"rollback": "Geri Alma",
	"rollover_progress": "Rollover İlerlemesi",
	"rotate_seed_pair": "Seed Çiftini Döndür",
	"roulette": "Rulet",
	"rugby": "Ragbi",
	"rule_1": "1. Spam yapma, taciz etme veya diğer kullanıcılara karşı kırıcı olma. Ayrıca CAPS kullanmaktan kaçın! Kimse bağırılmayı sevmez!",
	"rule_2": "2. Dilencilik yapma veya borç isteme; rain, tip ya da coin ikiye katlama talep etme.",
	"rule_3": "3. Potansiyel dolandırıcılık olarak görülebilecek şüpheli davranışlar yasaktır.",
	"rule_4": "4. Reklam / takas / satış / satın alma veya hizmet teklif etme gibi faaliyetlere girme.",
	"rule_5": "5. URL kısaltıcı kullanma. Her zaman orijinal linki gönder.",
	"rule_6": "6. Lütfen sohbet odasında İngilizce kullanın",
	"rules": "Kurallar",
	"santa_still_pays": "Santa hâlâ ödüyor",
	"saveBirthdayButtonText": "Doğum Gününü Kaydet",
	"saveButtonText": "Kaydet",
	"scan_the_qr_code_with_your_mobile_device_if_you_prefer": "İstersen QR kodunu mobil cihazınla tara.",
	"scan_verify": "QR kodunu kimlik doğrulayıcı uygulamanla tara",
	"schedule": "Plan",
	"scroll_to_see_leaderboards": "Liderlik tablolarını görmek için kaydır",
	"search": "Ara",
	"search_games": "Oyun Ara",
	"search_gifs": "GIF Ara",
	"searching": "Aranıyor...",
	"security": "GÜVENLİK",
	"security_tab": "Güvenlik",
	"see_less": "Daha az göster",
	"see_more": "Daha fazlasını gör",
	"seeds": "Seed’ler",
	"select": "Seç",
	"select_amount_withdraw": "Çekmek için bir tutar seç",
	"select_an_option": "Bir seçenek seç",
	"select_birthday_option": "Doğum Günü Seçeneği Seç",
	"select_currency": "Para birimi seç",
	"select_game": "Oyun Seç",
	"select_items_per_page": "Sayfa başına öğe",
	"select_network": "Yatırma için desteklenen bir ağ seç",
	"select_network_title": "Ağ seç",
	"select_network_withdraw": "Çekim için desteklenen bir ağ seç",
	"select_token": "Yatırmak için bir token veya para birimi seç",
	"select_token_withdraw": "Çekmek için bir token veya para birimi seç",
	"self_exclusion_description": "Bir mola gerekiyorsa kumardan bir süre uzaklaşabilirsin. Onaylandıktan sonra molan hemen başlar ve geri alınamaz.",
	"self_exclusion_duration_1_day": "1 Gün",
	"self_exclusion_duration_1_month": "1 Ay",
	"self_exclusion_duration_1_week": "1 Hafta",
	"self_exclusion_duration_1_year": "1 Yıl",
	"self_exclusion_duration_3_months": "3 Ay",
	"self_exclusion_duration_6_months": "6 Ay",
	"self_exclusion_duration_dropdown_placeholder": "Süre Seç",
	"self_exclusion_duration_indefinite": "Süresiz",
	"self_exclusion_duration_text": "Kendini dışlama süreni uzatmak istersen, yardım için lütfen Live Chat destek ekibimizle iletişime geç.",
	"self_exclusion_period_disabled": "Cooldown Talep Et",
	"self_exclusion_period_enabled": "Cooldown Süresi Aktif",
	"self_exclusion_period_requested": "Cooldown Süresi Talep Edildi",
	"self_exclusion_permanent_exclusion_button_text": "Kalıcı Olarak Kendini Dışla",
	"self_exclusion_permanent_exclusion_message": "Hesabını kendin dışlamak istiyorsan",
	"self_exclusion_permanent_exclusion_title": "Kalıcı Dışlama",
	"self_exclusion_reinstate_account_button_text": "Hesabı Yeniden Aktifleştir",
	"self_exclusion_reinstate_account_message": "Hesabını yeniden aktifleştirmek istiyorsan",
	"self_exclusion_reinstate_account_title": "Hesabı Yeniden Aktifleştir",
	"self_exclusion_tab": "Kendini Dışlama",
	"self_exclusion_warning_toast_message": "Kendini dışlama talebini göndermeden önce lütfen hesabındaki kalan bakiyeyi çek.",
	"self_exclusion_warning_toast_title": "Burada verilen her karar kesindir ve geri alınamaz",
	"self_family_referral_policy": "Kendimi veya aile üyelerimi yönlendirerek komisyon kazanabilir miyim?",
	"self_family_referral_policy_answer": "Hayır. Affiliate’lerin kendilerini veya aile üyelerini yönlendirmesi yasaktır. Bu politika, affiliate programında adalet ve bütünlüğü korumak için uygulanır.",
	"selfie": "SELFIE",
	"send_an_email": "E-posta Gönder",
	"send_code": "Kodu gönder",
	"send_only": "Yalnızca gönder",
	"send_only_warning": "Buraya başka bir coin göndermek, yanlış ağı kullanmak veya minimum yatırma tutarından daha az göndermek fon kaybına neden olur.",
	"send_the_amount_meme_coins": "Meme Coin tutarını self-custody cüzdanından NoDex Pay ile gönder. {BRAND_TITLE} hesabında {CURRENCY} karşılığını alacaksın.",
	"send_the_amount_of": "Şu tutarı gönder:",
	"send_tip": "Bahşiş gönder",
	"server_seed": "Server Seed",
	"set_as_default_campaign": "Varsayılan kampanya olarak ayarla",
	"set_up_your_campaign": "Kampanyanı ayarla",
	"settings": "Ayarlar",
	"settings_bet_feed_username": "Bet feed Kullanıcı Adı",
	"settings_joined_date": "Katılma Tarihi",
	"settings_leaderboards_username": "Leaderboards Kullanıcı Adı",
	"settings_marketing_emails": "Pazarlama E-postaları",
	"settings_private": "Gizli",
	"settings_public": "Herkese Açık",
	"setup": "KURULUM",
	"share_via_socials": "Sosyal medyada paylaş",
	"share_via_socials_message": "💸 Benim referral linkimle [BRAND]’a kayıt ol & birlikte %35 komisyon kazanabiliriz. Casino oyunları oyna, spora bahis yap ve [BRAND]’ta eğlen!",
	"share_via_socials_message_flush": "💸 Benim referral linkim veya kodumla flush.com’a kayıt ol ve $200 bonus kazan. Casino oyunları oyna, spora bahis yap, kripto kazan ve Flush’ta eğlen!",
	"share_via_socials_message_fomo": "fomo.io’da oynuyorum ve geniş Casino & Sports bahis seçeneklerini, özel özellikleri ve ödülleri çok seviyorum. \nReferral linkimle kayıt ol ve ilk yatırmanda $300’a kadar %100 bonusla başla.🤑\nBuraya tıkla:",
	"share_via_socials_text": "Yeni referral’lar kazanmak ve ödül elde etmek için referral linkini sosyal ağlarda arkadaşlarınla paylaş.",
	"share_your_message": "Bu metin, görselle birlikte sosyal ağlarında paylaşılacak.",
	"share_your_rewards": "Ödüllerini Paylaş",
	"share_your_rewards_text": "Bir referral kampanyası oluştururken komisyon ödüllerini arkadaşlarınla paylaşmayı ayarla. Daha çok oynamaları ve seninle birlikte kazanmaları için onları motive et!",
	"shared": "Paylaşıldı",
	"show": "Göster",
	"show_full_birthday": "Doğum tarihinin tamamını göster",
	"show_less": "Daha Az Göster",
	"show_more": "Daha Fazla Göster",
	"show_only_day": "Sadece günü göster",
	"show_only_month": "Sadece ayı göster",
	"sidebar_jackpot_banner_aria_label": "Jackpot {amount}",
	"sign": "İmzala",
	"sign_up": "Kayıt Ol",
	"sign_up_text": "Kayıt ol",
	"sign_up_today_call_to_action": "Bugün kayıt ol, VIP rank’larında yolculuğuna başla ve Rakeback, Cashback ve daha fazlasını kap! Ne kadar çok oynarsan rank’in o kadar yükselir, ödüllerin o kadar büyür!",
	"signature_required": "İmza gerekli",
	"signup": "Kayıt Ol",
	"signup_bonus_150": "%150 kayıt bonusu!",
	"signup_via_wallet": "Cüzdan ile kayıt ol",
	"silver": "Silver",
	"similar_games": "Benzer Oyunlar",
	"sixdigit": "6 haneli",
	"ski_jumping": "Ski Jumping",
	"slots": "Slotlar",
	"slots_live": "Slotlar/Canlı",
	"snooker": "Snooker",
	"something_went_wrong": "Bir şeyler ters gitti",
	"soon": "Yakında!",
	"sorry_text": "Üzgünüz! Görünüşe göre {BRAND}’e kısıtlı bir bölgeden erişmeye çalışıyorsun!",
	"sort_by": "Sırala",
	"sound": "Ses",
	"specials": "Özel",
	"spin": "Spin",
	"spin_again": "Yeniden Spin",
	"sport": "Spor",
	"sport_betting": "Spor Bahisleri",
	"sports": "Spor",
	"sports_description": "Futbol, Tenis, NBA\nve daha fazlasına en yüksek oranlarla bahis yap.",
	"sports_subtitle": "Ayda 200.000+ maç",
	"sports_terms": "Spor Şartları",
	"sportsbook": "Sportsbook",
	"squash": "Squash",
	"stakes_range": "Bahis Aralığı",
	"starcraft": "Starcraft",
	"start_earning_today": "Bugün kazanmaya başla",
	"start_inviting_your_friends": "Arkadaşlarını davet etmeye başla",
	"start_now": "Hemen Başla",
	"started": "Başladı",
	"starting_shortly": "Az sonra başlıyor",
	"starts": "Başlar",
	"statistics": "İstatistikler",
	"status": "Durum",
	"step_1_description": "Kayıt ol, yatırma yap ve gerçek parayla bahis yap.",
	"step_1_text": "Adım 1",
	"step_2_description": "Referral linkini kullanarak arkadaşlarını Flush.com’a davet et ve onların da aynısını yapmasını teşvik et.",
	"step_2_text": "Adım 2",
	"step_3_description": "Referral’larının oyununa göre her ay nakit ödül kazan.",
	"step_3_text": "Adım 3",
	"strategies_to_increase_earnings": "[BRAND] partneri olarak kazancımı artırmak için hangi stratejileri kullanabilirim?",
	"strategies_to_increase_earnings_answer": "Kazancını artırmanın en kritik yolu referral hacmini büyütmektir; ancak kullanabileceğin farklı stratejiler de var. Örneğin, farklı landing page’ler kullanmak veya belirli bir bonus teklifini öne çıkarmak. [BRAND] Partners ekibiyle iletişime geç; deneyimli bir yönetici en uygun yaklaşımı bulmanda yardımcı olacaktır.",
	"submit": "Gönder",
	"submitInfoButtonLabel": "Bilgileri Gönder",
	"subscribe": "Abone Ol",
	"succeeded": "Başarılı",
	"super_bowl_free_bet": "Super Bowl Bahis Yap ve Kazan",
	"super_bowl_free_bet_description": "Büyük Maça bahis yapın. Kazanın veya kaybetmeniz fark etmez, $5 Bonus Bahis kazanın.",
	"super_scatter": "Super Scatter Günlük Turnuvalar",
	"super_scatter_description": "Günlük ödüllerdeki $2.5M payı için bu Super Scatter games oyunlarını çevir!",
	"super_scatter_series_daily_tournaments": "Super Scatter Serisi",
	"super_scatter_series_daily_tournaments_description": "1.8m+ değerinde günlük turnuvalar",
	"support": "Destek",
	"support_and_play": "favori takımını destekle",
	"support_chat_account_help": "Hesap Yardımı",
	"support_chat_agent_follow_up": "Hesap erişimi, ödemeler, doğrulama ve ödüller konusunda yardımcı olabilirim. Destek ekibine ulaşmak için yazmaya devam edebilirsiniz.",
	"support_chat_agent_intro": "Bir soru sorun, sık kullanılan konulara göz atın veya destek ekibimizle sohbet başlatın.",
	"support_chat_agent_reply": "Merhaba! Ben destek asistanınızım. Neye ihtiyacınız olduğunu söyleyin, doğru cevabı bulmanıza yardımcı olayım.",
	"support_chat_ai_agent": "AI Agent",
	"support_chat_ask_a_question_placeholder": "Bir soru sorun...",
	"support_chat_ask_your_question": "Sorunuzu sorun",
	"support_chat_conversation_closed": "Bu görüşme kapatıldı.",
	"support_chat_conversation_resolved": "Bu görüşme çözüldü. Teşekkürler!",
	"support_chat_depositing_usdt": "USDT Yatırma",
	"support_chat_handoff_notice": "Bir destek temsilcisi kısa süre içinde katılacak.",
	"support_chat_home": "Ana Sayfa",
	"support_chat_how_can_we_help": "Size nasıl yardımcı olabiliriz?",
	"support_chat_human_agent": "Destek temsilcisi",
	"support_chat_message_meta": "{brand} · {agent} · {time}",
	"support_chat_message_meta_without_time": "{brand} · {agent}",
	"support_chat_messages": "Sohbetler",
	"support_chat_messages_empty_description": "Sohbetiniz başladığında ekipten gelen mesajlar burada görünecek.",
	"support_chat_money_matters": "Ödemeler ve Finans",
	"support_chat_no_messages": "Henüz mesaj yok",
	"support_chat_perks_and_promos": "Ayrıcalıklar ve Promosyonlar",
	"support_chat_quick_questions": "Hızlı Sorular",
	"support_chat_search_for_help": "Yardım ara",
	"support_chat_search_in_articles": "Makalelerde ara",
	"support_chat_sender_meta": "{sender} · {time}",
	"support_chat_two_step_verification": "İki Adımlı Doğrulama",
	"support_chat_vip_rewards_explained": "VIP ödülleri açıklandı",
	"support_chat_welcome_bonus": "Flush Hoş Geldin Bonusu",
	"support_chat_withdrawals_usdt": "USDT Çekme",
	"support_details": "Affiliate desteği; İngilizce, Rusça, Japonca, Portekizce ve Çince dahil birçok dilde mevcuttur.",
	"support_in_multiple_languages": "Birden Fazla Dilde Destek",
	"support_your": "Destekle",
	"svelte_component": "Svelte Bileşeni",
	"sweet_bonanza": "$2,100,000 Kapılacak!",
	"switch_inputs": "Girdileri değiştir",
	"table_games": "Masa Oyunları",
	"table_tennis": "Masa Tenisi",
	"tailored_reload_bonuses_text": "Özel Reload Bonusları",
	"take_your_shot_today": "Bugün şansını dene!",
	"ten_per_page": "10 öğe/sayfa",
	"tennis": "Tenis",
	"terms": "Şartlar",
	"terms_and_conditions": "Şartlar ve Koşullar",
	"terms_and_conditions_1": "Yarış {startDate} ile {endDate} arasında gerçekleşir. Bu aralığın dışındaki bahisler sayılmaz.",
	"terms_and_conditions_10": "Haksız uygulamalardan şüphelenilen herhangi bir oyuncu, Flush Casino’nun takdirine bağlı olarak diskalifiye edilebilir.",
	"terms_and_conditions_11": "Meydan okuma için birden fazla hesap kullanan oyuncular diskalifiye edilir.",
	"terms_and_conditions_2": "Bu, bahis temelli bir meydan okumadır; liderlik tablosundaki final sıran ödülünü belirler.",
	"terms_and_conditions_3": "Ödüller, promosyon bittikten sonra 24 saat içinde Flush hesabına aktarılır. Ödül, Rewards açılır menüsünden talep edilmelidir. Talep edildikten sonra ödülün %50’si anında oyuncunun bakiyesine aktarılır. Kalan %50, Rewards Calendar üzerinden 14 ardışık gün boyunca dağıtılır",
	"terms_and_conditions_4": "Liderlik tablosundan gelen ödüllerin çevrim şartı yoktur.",
	"terms_and_conditions_5": "Yalnızca uygun oyunlarda yapılan bahisler liderlik tablosundaki konumuna katkı sağlar.",
	"terms_and_conditions_6": "Bahislerin sayılması için minimum bahis $0.20 olmalıdır.",
	"terms_and_conditions_7": "Yalnızca gerçek para bahisleri geçerlidir. Yatırma bonuslarıyla veya promosyonlardan gelen free spinlerle yapılan bahisler sayılmaz.",
	"terms_and_conditions_8": "Katılarak, bu promosyon kurallarını ve Flush Casino’nun Genel Şartlar ve Koşullarını kabul etmiş olursun.",
	"terms_and_conditions_9": "Flush Casino, gerektiğinde promosyon detaylarını değiştirme hakkını saklı tutar.",
	"terms_and_conditions_title": "Promosyon Şartları ve Koşulları:",
	"terms_of_service": "Hizmet Şartları",
	"testimonial_1_text": "“Flush, farklı sağlayıcılardan geniş bir slot seçkisi sunan mükemmel bir online casino. Birden fazla kripto para birimini destekliyor; bu da işlem yapmayı çok daha pratik hale getiriyor!”",
	"testimonial_2_text": "“Bu casinoya bayıldım! Tüm favori oyunlarım var ve kriptoyu doğrudan banka veya kredi kartınla satın alabiliyorsun—üçüncü taraf aracıya gerek yok. Cashout’lar anında ve birçok seçenek sunuyor. Üstelik destek ekibi harika—çok yardımcı ve güler yüzlü!”",
	"testimonial_3_text": "“Bu online kripto casino gerçekten müthiş ve parlak bir geleceği var; hem ara sıra oynayanlar hem de düzenli oyuncular için ideal. Canlı destek çok hızlı yanıt veriyor, teknik ekip de çok ilgili. Gönülden tavsiye ederim. Deneyimim sorunsuzdu, bug yoktu ve çekimler anındı. Bu casinoyu takipte kalın—kesinlikle izlenmeye değer”",
	"testimonial_4_text": "“Harika bir casino! Bu platformdaki deneyimim mükemmeldi, şu ana kadar hiçbir şikayetim yok. Kesinlikle en iyi tercihlerimden biri. Flush, oyununu güçlendirmek için geniş bir oyun yelpazesi ve cazip bonuslar sunuyor. Yatırmalar ve ödemeler hızlı ve zahmetsiz. Ayrıca destek ekibi dost canlısı ve hızlı yanıt veriyor.”",
	"testimonials_text": "Yorumlar",
	"the_value_of_the": "Şunun değeri:",
	"third_party": "Devam etmek seni üçüncü taraf bir hizmete yönlendirecek.",
	"thousand_of_games": "binlerce oyuna",
	"thousands_of_casino_games": "Binlerce Casino Oyunu",
	"tier": "Tier",
	"tier1_referrals": "Tier 1 (birincil referral’lar)",
	"tier2_referrals": "Tier 2 (ikincil referral’lar)",
	"tier3_referrals": "Tier 3 (üçüncül referral’lar)",
	"tier_name_text": "Tier Adı",
	"time": "Zaman",
	"timer_days": "GG",
	"timer_hours": "SS",
	"timer_minutes": "DD",
	"timer_seconds": "SN",
	"timezone_gmt_plus_7": "(GMT+7)",
	"tip": "Tip",
	"tip_amount": "Tip tutarı",
	"tip_below_minimum": "Tip tutarı izin verilen minimumun altında.",
	"tip_error": "Tip gönderilirken bir hata oluştu.",
	"tip_exceeds_balance": "Tip tutarı mevcut bakiyeni aşıyor.",
	"tip_exceeds_maximum": "Tip tutarı izin verilen maksimumu aşıyor.",
	"tip_invalid": "Geçersiz Tip",
	"tip_network_error": "Tipin gönderilirken bir hata oluştu. Lütfen daha sonra tekrar dene.",
	"tip_sent": "Tip Gönderildi",
	"tip_sent_success": "Tip başarıyla gönderildi.",
	"tip_too_large": "Tip Çok Büyük",
	"tip_too_small": "Tip Çok Küçük",
	"titanium": "Titanium",
	"title": "Kartla Öde, Kriptoyla Oyna",
	"to_enable_login_via_wallet_please_click_sign_and_then_go_to_your_wallet_to_view_and_confirm_this_message": "Cüzdan ile girişi etkinleştirmek için İmzala’ya tıklayın ve ardından cüzdanınızdan bu mesajı onaylayın",
	"to_get": "almak için",
	"to_next_lvl": "Sonraki Seviyeye",
	"to_this_address": "şu adrese",
	"today": "Bugün",
	"token_balance_label": "{token} Bakiyesi",
	"tokens": "Token’lar",
	"top_card_live_casino_description": "Canlı Blackjack,\nRulet ve Baccarat oyna",
	"top_card_live_casino_title": "Canlı Casino",
	"top_direct_referrals": "En İyi 5 Birincil Referral",
	"total": "Toplam",
	"total_balance": "Toplam Bakiye",
	"total_bets": "Toplam Bahisler",
	"total_bets_made_with_pair": "Bu Çift ile Yapılan Toplam Bahis",
	"total_claimed_rewards": "Toplam talep edilen ödüller",
	"total_earnings": "Toplam Kazanç",
	"total_level_up_rewards_text": "Level Up Ödülleri",
	"total_referrals": "Toplam referral",
	"total_referrals_table_tooltip": "Referral linkini veya referral’larının linkini kullanarak başarıyla oluşturulan toplam hesap sayısı. Bu ay aktif olup olmadıklarına bakılmaksızın.",
	"total_rewarded": "Toplam Ödüllendirilen",
	"total_tips": "Gönderilen/Alınan Toplam Tip",
	"total_wager": "Toplam Bahis",
	"total_wagered": "Toplam Bahse Girilen",
	"totp_setup": "TOTP Ayarlama",
	"totp_verify": "TOTP Doğrulama",
	"tournaments": "Turnuvalar",
	"tournaments_and_raffles_description": "Nakit Ödüller ve Nakit Free Spin’ler Kazan",
	"tournaments_and_raffles_first_part_title": "TURNUVALAR & ÇEKİLİŞLER",
	"tournaments_and_raffles_second_part_title": " ",
	"tournaments_and_raffles_title_highlight": " ",
	"tournaments_description": "Nakit Ödüller ve Nakit Free Spin’ler Kazan",
	"transaction": "İşlem",
	"transactions": "İşlemler",
	"transparency": "Şeffaflık",
	"transparency_100_percent_towards_tier_3": "Tier 3’e %100",
	"transparency_all_bets_made_on_our_site_last_month": "Geçen ay aktif oyunlarda ortalama RTP.",
	"transparency_asked_questions": "Sorulan Sorular",
	"transparency_audits_description": "Adaleti istediğin zaman doğrulayabilmen için en iyi laboratuvarlardan güncel sertifikaları ve test raporlarını yayınlıyoruz.",
	"transparency_average_payout_speed": "Çekim Hızı",
	"transparency_average_response": "Destek Yanıtı",
	"transparency_avg_time_real_person_responds": "Canlı sohbette ilk yanıtın ortalama süresi.",
	"transparency_bonus_terms_description": "Sürpriz yok. Net wagering, örnekler ve uygunluk — katılmadan önce özetlenir.",
	"transparency_bonus_terms_plain": "Basit Dille Bonus Şartları",
	"transparency_clear_tiers": "Net Tier’lar",
	"transparency_deposit_500_bet": "$50 yatır, $50 bonus al → açmak için toplam $2.000 wager yap.",
	"transparency_earn_play_description": "Volatilite, bankroll ipuçları ve RNG’lerin nasıl çalıştığına dair rehberler ve videolar — çünkü bilgi herkesindir.",
	"transparency_earn_play_smarter": "Kazan & Daha Akıllı Oyna",
	"transparency_earn_real_rewards": "Gerçekten anlayabileceğin bir programla gerçek ödüller kazan",
	"transparency_every_month": "her ay",
	"transparency_fair_bonuses": "Adil Bonuslar",
	"transparency_fair_bonuses_description": "Basit dilde şartlar, gerçek örnekler.",
	"transparency_fair_examples": "Adil Örnekler",
	"transparency_fair_play_report": "Adil oyun raporu",
	"transparency_faq_bonus_wagering_a": "Katılmadan önce temel şartları özetliyoruz ve gerçek örneklerle bir hesaplayıcı sunuyoruz; böylece neyin gerektiğini her zaman bilirsin.",
	"transparency_faq_bonus_wagering_q": "Bonus wagering nasıl?",
	"transparency_faq_fast_withdrawals_a": "Onaylanan çekimlerin çoğu 24 saat içinde bizden çıkar. Banka ve ağ süreleri yönteme göre değişir; onaylamadan önce canlı bir ETA gösteriyoruz.",
	"transparency_faq_fast_withdrawals_q": "Çekimler ne kadar hızlı?",
	"transparency_faq_language_a": "Bonus şartlarının jargonsuz, sade bir dille ve gerçek örneklerle verilmesi gerektiğine inanıyoruz. Nasıl işlediğini görmek için herhangi bir bonus teklifimize göz at.",
	"transparency_faq_language_q": "‘Sade dilde’ bonus şartları ne demek?",
	"transparency_faq_responsible_play_a": "Evet — yatırma limitleri, seans hatırlatıcıları, cool-off ve kendini dışlama profilinde mevcut. Ayrıca bağımsız yardım kaynaklarına da bağlantı veriyoruz.",
	"transparency_faq_responsible_play_q": "Sorumlu oyun desteğiniz var mı?",
	"transparency_faq_verify_fairness_a": "Her oyunda bir sertifika bağlantısı ve bir RNG denetim sayfası vardır. Laboratuvar raporlarını ve test metodolojisini incelemek için oyun başlığının yanındaki rozete tıkla.",
	"transparency_faq_verify_fairness_q": "Adaleti nasıl doğrularım?",
	"transparency_fast_withdrawals": "Hızlı Çekimler",
	"transparency_fast_withdrawals_description": "Net zaman çizelgeleri, sürpriz gecikme yok.",
	"transparency_features_description": "İnce yazılara gömülmeden, bilinçli seçimler yapabilmen için önemli şeyleri öne çıkarıyoruz.",
	"transparency_frequently": "Sık",
	"transparency_frequently_asked": "Sık Sorulan",
	"transparency_hero_description": "Kuralları saklamıyoruz. Öne çıkarıyoruz. Adil oyunlar, net ödemeler ve gerçek insanlardan destek — böylece güvenle oynarsın.",
	"transparency_how_we_are_fair": "Nasıl adiliz",
	"transparency_human_support": "İnsan destek kapsamı",
	"transparency_human_support_247": "7/24 İnsan Destek",
	"transparency_independent_audits": "Bağımsız Denetimler",
	"transparency_loyalty_description": "Şeffaf tier’lar, gerçek örnekler ve ilerleme takibi — çünkü sadakat iki yönlü olmalı.",
	"transparency_loyalty_that_feels_fair": "Adil hissettiren sadakat",
	"transparency_manifesto": "Manifesto",
	"transparency_manifesto_1": "Her oyunun nasıl çalıştığını söyleriz; RTP ve house edge, ihtiyaç duyduğun yerde görünür.",
	"transparency_manifesto_10": "Şeffaflık bir özellik değil. Bizim kimliğimiz.",
	"transparency_manifesto_2": "Paran hızlı ve net hareket eder; öngörülebilir zaman çizelgeleri ve gizli ücretler yok.",
	"transparency_manifesto_3": "Seninle insan gibi konuşuruz ve hatalarımızı sahipleniriz.",
	"transparency_manifesto_4": "Sorumlu oyun araçları: limitler, time-out’lar ve kendini dışlama dahili.",
	"transparency_manifesto_5": "Hak edilmiş gibi hissettiren sadakat — şeffaf tier’lar ve anlamlı ayrıcalıklar.",
	"transparency_manifesto_6": "Adaletimiz bağımsız şekilde doğrulanır — sertifikalar ve lab raporları herkese açıktır.",
	"transparency_manifesto_7": "Gizli şartlar yok — bonuslar sade dille, gerçek örneklerle açıklanır.",
	"transparency_manifesto_8": "Herkes için bilgi — daha akıllı oynamana yardımcı olan rehberler.",
	"transparency_manifesto_9": "Önemli sayıları aylık Fair Play Report’ta yayınlarız.",
	"transparency_manifesto_description": "Şeffaf casino. Bizi tanımlayan ve nasıl çalıştığımızı belirleyen şey. Çünkü güven, iyi bir oyun deneyiminin temelidir.",
	"transparency_median_time_from_withdrawal_request": "Onaylanan çekimlerde cüzdana ulaşmanın medyan süresi.",
	"transparency_payout_ratio": "Ödeme oranı",
	"transparency_payouts_description": "Çekim zaman çizelgelerimiz ve limitlerimiz herkese açık, tutarlı ve hesabında kolayca takip edilebilir.",
	"transparency_payouts_processed": "Ort. ödemeler <48 saatte işlendi",
	"transparency_player_first": "Oyuncu Öncelikli",
	"transparency_player_first_description": "Limit araçları, kendini dışlama ve destek.",
	"transparency_playersss": "OYUNCULARRR",
	"transparency_predictable_payouts": "Öngörülebilir Ödemeler",
	"transparency_progress_towards": "% şu yöne",
	"transparency_questions": "Sorular",
	"transparency_rng_certified": "RNG Sertifikalı",
	"transparency_rng_description": "En iyi lab’lar tarafından bağımsız şekilde doğrulandı.",
	"transparency_rtp_description": "Return-to-player ve house edge’i kartlarda ve oyun içinde net şekilde gör — yanında basit bir “Neden önemli?” açıklamasıyla.",
	"transparency_rtp_on_every_game": "Her oyunda RTP",
	"transparency_see_your_progress": "İlerlemeni gör",
	"transparency_support_description": "Gerçekten çözüm üretebilen gerçek insanlarla konuş. Yanıt süresi istatistiklerini aylık yayınlıyoruz.",
	"transparency_the_transparency": "Şeffaflık",
	"transparency_tier_1_5_percent": "Tier 1: %5 cashback — gizli koşul veya ince yazı yok",
	"transparency_tier_2_cashback": "%5 cashback",
	"transparency_tier_2_faster": "Tier 2: Daha hızlı çekimler ve özel bonuslar — çünkü daha akıllısını hak ediyorsun",
	"transparency_tier_2_label": "Tier 2",
	"transparency_tier_3_faster_withdrawals": "daha hızlı çekimler",
	"transparency_tier_3_label": "Tier 3",
	"transparency_tier_3_vip": "Tier 3: VIP özel destek & erken erişim",
	"transparency_tier_explanation": "Seviye atlamak için wagering kilometre taşlarına ulaş — gizli koşul veya ince yazı yok.",
	"transparency_tier_hit_milestones": "Seviye atlamak için basit kilometre taşlarına ulaş — gizli koşul veya ince yazı yok.",
	"transparency_transparency": "Şeffaflık",
	"transparency_vip_label": "VIP",
	"transparency_vip_support_early_access": "özel destek & erken erişim",
	"transparency_we_publish_our_numbers": "Rakamlarımızı yayınlıyoruz — her ay",
	"transparency_where": "Nerede",
	"transparency_win_shown_last_12_mo": "Son 12 ay çekilen",
	"transparency_wins": "Kazançlar",
	"transparency_wins_title": "Şeffaflık Kazanımları",
	"transparency_you_can_see": "Görebileceğin şeffaflık — her oynadığında",
	"triple_rakeback_description": "Günün ilk 60 dakikasında Rakeback’ini üçe katla! Bunu günlük, haftalık ve aylık olarak; daha uzun süreler ve ekstra boostlarla da alabilirsin.",
	"triple_your_rakeback": "Her gün ilk 60 dakika Rakeback’ini üçe katla!",
	"try_again": "Tekrar dene",
	"try_it_now": "Hemen dene",
	"try_your_luck": "Şansını dene",
	"turbo_jackpot_logo_alt": "Turbo Jackpot Drop",
	"turboslots_all_rights_reserved": "Turboslots. Tüm Hakları Saklıdır",
	"turboslots_bets": "Turbo Bahisleri",
	"turn_every_spin_into_cash_prizes": "Her spin’i nakit ödüllere çevir",
	"twenty_per_page": "20 öğe/sayfa",
	"twoStepVerification": "İki Adımlı Doğrulama",
	"twofa": "İki Faktörlü Kimlik Doğrulama (2FA)",
	"twofa_setup": "TOTP (2FA) Kurulumu",
	"twofa_totp_code": "twofa_totp_code",
	"unknown": "Bilinmiyor",
	"unlock_the_bonus": "Bonusu aç",
	"unlocked_balance": "Kilitli olmayan bakiye",
	"unlocking": "Referral Ödül Kuralları",
	"unlocking_rules": "Referral Ödül Kuralları:",
	"unlocking_rules_text": "Referral bonusların, referral’larının toplam bahsi arttıkça eş zamanlı olarak açılır. Açılan bonus parçaları BFG token’ları olarak çekime uygun hale gelir. Ödemeyi aldıktan sonra bunlarla oynayabilir veya platformdan çekebilirsin.",
	"unread": "Okunmamış",
	"unsubscribe": "Abonelikten Çık",
	"unverified": "doğrulanmamış",
	"unwrap_daily_wins": "Günlük kazançları aç: Her hediyenin arkasında ödüller var!",
	"up_to": "En fazla",
	"up_to_3000_bonus_on_your_first_3_deposits": "İlk 3 yatırımında 3.000 $'a kadar\nbonus",
	"up_to_x_bonus_on_your_first_x_deposits": "İlk [NUMBER_OF_DEPOSITS] yatırımında + [BONUS_AMOUNT] Bonus’a kadar",
	"upcoming": "Yaklaşan",
	"upcoming_referral_reward": "Yaklaşan Referral Ödülü",
	"upcoming_reward": "Yaklaşan Rank Up Ödülü",
	"upcoming_rewards": "Yaklaşan Ödüller",
	"user": "Kullanıcı",
	"user_banned": "[BRAND] hesabına artık erişimin yok.",
	"user_id": "KULLANICI ID",
	"user_not_eligible": "Bu kullanıcı tip almaya uygun değil.",
	"username": "Kullanıcı adı",
	"validation_error": "Doğrulama Hatası",
	"value_may_change": "ödemenizi aldığımız zamana kadar değişebilir",
	"verification": "DOĞRULAMA",
	"verification_code": "İki Faktörlü Kimlik Doğrulama kodunu gir",
	"verification_tab": "Doğrulama",
	"verify": "Doğrula",
	"vibranium": "Vibranium",
	"video_poker": "Video Poker",
	"view": "Görüntüle",
	"viewAll": "Tümünü Gör",
	"view_all": "Tümünü Gör",
	"view_all_pending_rewards": "Tüm bekleyen ödülleri gör",
	"view_all_ranks": "Tüm Rank’ları Gör",
	"view_calculation_breakdown": "Hesaplama Dökümünü Gör",
	"view_my_accrual_history": "Birikim geçmişimi görüntüle",
	"view_vip_level_details_text": "VIP seviye detaylarını görüntüle",
	"vip": "VIP Club",
	"vip_benefits_text": "VIP Avantajları",
	"vip_club": "Vip Club",
	"vip_club_description": "Rakeback, Cashback ve Daha Fazlasının Keyfini Çıkar",
	"vip_club_text": "VIP Club",
	"vip_desc": " kaç kişiyi davet edebileceğin hakkında. Ve ne kadar çok oynarlarsa, o kadar çok kazanırlar.",
	"vip_description": "+$2,000,000 ödül. Etrafın en iyi VIP Club’ı",
	"vip_galaxy": "VIP Galaxy",
	"vip_level": "limit yok",
	"vip_program": "VIP Programı",
	"vip_rank_rewards": "VIP Rank Ödülleri",
	"vip_rewards": "VIP Ödülleri",
	"vip_testimonials_text": "VIP Yorumları",
	"volatility": "Volatilite",
	"voleyball": "Voleybol",
	"wager": "Wager",
	"wager_house_edge_commission": "Wager * House * Edge * Komisyon %",
	"wager_on_providers": "[PROVIDERS] üzerinde [WAGER_AMOUNT] wager yap",
	"wager_required": "Gerekli Kâr",
	"wager_requirements": "Wager Şartları",
	"wagered": "Bahse girilen",
	"wagering_progress": "Bahis İlerlemesi",
	"wagering_required": "Wager Gerekli",
	"wagers_in_feed": "Bet Feed’deki Bahisler",
	"wallet": "Cüzdan",
	"wallet_address": "Cüzdan adresi",
	"wallet_not_eligible": "Seçtiğin cüzdan tip göndermeye uygun değil.",
	"want_to_be_affiliate": "Hâlâ soruların mı var? [BRAND] affiliate’i olmak mı istiyorsun? Aşağıdan [BRAND] Partners ile iletişime geç",
	"warning": "Uyarı",
	"water_polo": "Su Topu",
	"waterpolo": "Su Topu",
	"we_ve_dropped_into_your_balance": "[AMOUNT] tutarını bakiyene ekledik — buna bir Noel kurtarışı de.",
	"weekly": "Haftalık Bonus",
	"weekly_bonus": "Haftalık bonus",
	"weekly_bonus_text": "Haftalık Bonus",
	"weekly_bonuses_text": "Haftalık Bonuslar",
	"weekly_limit": "Haftalık çekim limitlerine ulaştın. Limitlerin yenilenmesi için lütfen [TIME] gün sonra tekrar dene.",
	"weekly_race": "Haftalık Yarış",
	"weekly_races": "Haftalık\nYarışlar",
	"weekly_races_description": "Her hafta 10.000 $ ödül için yarış ve kazanmaya ilerle!",
	"weekly_raffle": "Haftalık\nÇekiliş",
	"weekly_raffle_description": "One Ticket\nOne Winner\n$500 Cash",
	"weekly_rewards_tooltip": "Haftalık aktiviteye dayalı bonus. Bakiyene ve 7 günlük takvimine aktarılır.",
	"welcome": "Hoş Geldin!",
	"welcome_back": "Tekrar Hoş Geldin",
	"welcome_bonus": "Hoş Geldin\nBonusu",
	"welcome_description": "İlk 3 yatırmada maksimum değer",
	"welcome_message": "Flush’ta ödüllerin zirvesine hoş geldin; burada VIP’ler eşsiz ayrıcalıklarla karşılanır. Her gün, hafta ve ay özel bonuslarla dolu bir dünyaya dal! Rank’larda yükseldikçe daha büyük ödüllerin kilidini aç, house edge’den payını al ve üstün ayrıcalıklarla deneyimini güçlendir.",
	"welcome_modal_button_text": "Harika!",
	"welcome_modal_description": "Önceki aktiviten önümüzdeki birkaç hafta içinde içe aktarılacak ve VIP seviyen, önceki wagering’ini yansıtacak şekilde yükseltilecektir.",
	"welcome_modal_subtitle_first_part": "Hoş geldin",
	"welcome_modal_subtitle_second_part": "Flush V2",
	"welcome_modal_title": "Web Sitesi Güncellemesi",
	"welcome_offer": "275% Hoş Geldin Bonusu",
	"welcome_offer_description": "İlk 3 yatırmanda $3,000’a kadar",
	"welcome_offer_description_text": "[NUMBER_OF_DEPOSITS] Yatırma Bonusu [PERCENTAGE]%’e kadar",
	"welcome_offer_text": "[Hoş Geldin] Teklifi",
	"welcome_to": "FLUSH Original Crypto Casino’ya Hoş Geldin! ",
	"welcome_to_brand": "[BRAND]’e Hoş Geldin",
	"welcome_to_fomoio": "Fomo.io’ya Hoş Geldin",
	"welcome_to_the_pinnacle": "Flush’ta ödüllerin zirvesine hoş geldin; burada VIP’ler eşsiz ayrıcalıklarla karşılanır.",
	"welcome_to_vip_club_text": "VIP Club’a Hoş Geldin!",
	"what_should_you_play": "Bugün BÜYÜK kazanmak için ne oynamalısın? Şanslı olan sen misin? DENE!",
	"wheel": "Çark",
	"why_choose_partners": "Neden [BRAND] Partners’ı seçmelisin?",
	"will_receive_equivalent": "aşağıdaki adrese yatırmak istiyorsun. Karşılığını {currency} olarak alacaksın.",
	"win": "Kazan",
	"win_ways": "Kazanma Yolları",
	"with_rewards": "Ödüllerle Flush!",
	"withdraw": "Çek",
	"withdraw_cash": "Nakit Çek",
	"withdraw_disabled": "Hesabın şu anda çekim yapamıyor.",
	"withdrawal": "Çekim",
	"withdrawal_address": "Çekim adresi",
	"withdrawal_address_invalid": "Çekim adresi, bu cüzdan türü için gerekli formatla eşleşmiyor.",
	"withdrawal_amount": "Çekim tutarı",
	"withdrawal_approve": "Çekimi Onayla",
	"withdrawal_approve_text": "Fonlar gönderilecek. Lütfen çekim adresini doğrula.",
	"withdrawal_approve_text_with_amount": "{{amount}} {{currency}} alacaksın.<br />Lütfen adresin doğru olduğunu doğrula.",
	"withdrawal_error": "Çekimini onaylarken bir hatayla karşılaştık.",
	"withdrawal_expired": "Çekim süresi doldu, lütfen tekrar dene.",
	"withdrawal_fee": "Çekim ücreti",
	"withdrawal_min_amount": "Minimum çekim tutarı",
	"withdrawal_preview": "Çekimi Önizle",
	"withdrawal_requirement_deposit": "Çekim yapabilmek için önce yatırma işlemi yapmalısın.",
	"withdrawal_requirement_email": "Çekim yapabilmek için e-posta adresini eklemeli ve doğrulamalısın.",
	"withdrawal_requirement_ineligible_account": "Hesabın çekim işlemine uygun değil. Lütfen destek ile iletişime geç.",
	"withdrawal_sent": "Çekimin işleniyor. Tamamlandığında bir bildirim alacaksın.",
	"withdrawal_transaction_fee": "İşlem ücreti",
	"withdrawals": "Çekimler",
	"withdrawals_frozen": "Çekimin şu anda incelemede. Daha fazla yardım için lütfen Destek ile iletişime geç.",
	"withdrawals_not_supported": "ŞURAYA ÇEKİM DESTEKLENMİYOR:",
	"within_1_business_day": "1 iş günü içinde",
	"world_series_bad_beat_bailout": "World Series Bad Beat Bailout",
	"world_series_bad_beat_bailout_description": "Tek farkla kaybet, paran geri gelsin!",
	"write_here": "Buraya yaz",
	"write_your_message": "Mesajını yaz",
	"x_hours": "[QUANTITY] saat",
	"xmas_pursuit": "Xmas pursuit",
	"yearLabel": "Yıl",
	"yes": "Evet",
	"you_25_comission": "Komisyonun, doğrudan referral’larının, onların referral’larının ve hatta onların referral’larının yaptığı gerçek para bahislerinin <br><span class='yellow-text'>house edge</span>’ine göre hesaplanır.",
	"you_can_earn": "Flush’un referral programı, 3 seviyeli referral sistemi ve house edge’e göre %35’e kadar komisyonla seni ödüllendirir!",
	"you_get": "Sen alırsın",
	"you_must_first_wager_your_deposit_1_time_before_you_can_withdraw": "Çekim yapabilmek için önce yatırma işlemi yapmalısın.",
	"you_need_to_open_your_wallet_and_sign_to_approve": "Onaylamak için cüzdanınızı açıp imzalamanız gerekir",
	"you_receive": "Sen alırsın",
	"you_send": "Sen gönderirsin",
	"your": "Senin",
	"your_balance": "Bakiyen",
	"your_bonuses_unlocked": "Referral bonusların, referral’larının toplam bahsi arttıkça eş zamanlı olarak açılır. Ödüller nakit bakiye olarak verilir ve bu ödül için herhangi bir wagering şartı yoktur.",
	"your_commissions": "Komisyonun",
	"your_notifications": "Bildirimlerin",
	"your_rank": "Rank’in",
	"your_referral_code": "Referral kodun",
	"your_referral_link": "Referral linkin"
}
